import React from 'react';

const stringsData = {
    en: {
        // create profile
        yourProfileInThisHome: {
            header: "Your Profile in This Home",
            info: "You can use different profiles across different homes",
            popupInfo: "You should create a profile to use this home.",
            popupButton: "Continue creating your profile",
        },
        homeProfilePage: {
            createHeader: "New Solo Home",
            profleHeader: "Home’s Profile",
            info: "Create a new solo home to manage your solo devices",
            changeAvatar: "Change Home Avatar",
            homeNamePlaceholder: "Your Home Name",
            create: "Create",
        },
        welcome: "Welcome to Hinava",
        addToHomeScreen: {
            header: "Add Hinava web-application to your home screen",
            snooze: "Got it",
            messages: [
                <div className="text">1 - Tap on <div className="share">Share</div> button from tabbar.</div>,
                <div className="text">2 - In the opened menu select <div className="add-text">Add to Home screen</div>.</div>,
                <div className="text">3 - Tap on the <div className="add-button">Add</div> button.</div>
            ],
        },
        changeLanguage: "Change Language",
        selectHomeTypeInfoPlease: "Please select your home type",
        selectHomeTypeInfo: "Select your home type",
        homeType: {
            hub: "Hub",
            hubInfo: "Select to connect to your hub",
            solo: "Solo Cloud",
            soloInfo: "For devices without hub",
        },
        namePlaceHolder: "Your name",
        next: "Next",
        youMustEnterAName: "You must enter a name",

        // register home
        logoutSolo: "Logout From Solo",
        connectToHub: "Connect to Hinava Central Hub",
        connectToHubInfo: "Please enter the phone number you used for the central hub registration",
        gatewayNumber: "Hub number",
        connectToSolo: "Enter phone number",
        connectToSoloInfo: "Please enter your phone number to login into Solo Cloud",
        phoneNumber: "Phone number",
        verificationCode: "Verfication code",
        verificationCodeInfoF: "Please enter the verification code that was sent for {0}",
        sendingVerificationCode: "Sending the verification code",
        verifyingTheCode: "Logging in",
        useSimulatedGateway: "Use Simulated Hub!",
        connectToGateway: "Connecting to central hub",
        tryAnotherHub: "Try another hub",
        tryAnotherPhoneNumber: "Change phone number",
        waitingForAccept: "Waiting for accept",
        waitingForAcceptInfo: "Your request has been sent. Please accept the request on the hub.",
        youMustEnterAPN: "You must enter a phone number",
        youMustEnterTheCode: "You must enter the verification code",
        loadingSoloHomes: "Loading solo homes",
        creatingSoloHome: "Creating solo home",
        switchingSoloHome: "Switching to the new solo home",
        resendCodeLimit: "Resend limit exceeded",
        resendCode: "Resend the code",
        resendCodeInfoF: "You can send the code again after {0} seconds",
        codeWasWrong: "The entered code was wrong",

        // home-tab
        home: "Home",
        defaultHomeName: "Your Home",
        addHome: "Add Home",

        // connection status
        statusConnecting: "Connecting",
        statusUpdating: "Updating",
        dataIsLoading: "data is loading",
        statusStable: "Stable",

        // devices
        devices: "Devices", // list header
        addDevice: "Add Device",
        deleteAllDevices: "Delete All Devices",
        noDevice: "You haven’t any device yet",
        off: "OFF",
        doorbell: {
            ringing: "Ringing",
            tapToStop: "Tap to stop",
        },
        elevator: {
            calling: "Calling",
            tapToStop: "Tap to stop",
        },
        pumpOff: "Pump",
        slowOff: "Slow",
        fastOff: "Fast",
        closed: "Closed",
        open: "Open",
        motionDetected: "Motion Detected",
        motionNotDetected: "No Motion",
        soundDetected: "Sound Detected",
        soundNotDetected: "No Sound",
        percentFunc: (v) => v + "%",
        cDegreeFunc: (v) => v + "°C",
        noBatteryDetected: "no battery detected",
        deviceConnected: "Connected",
        deviceDC: "Disconnected", // in device list
        deviceDisonnected: "Disconnected", // in device detail
        reportsOfThisDevice: {
            label: "Device state chart",
            smallerLabel: "for the last 24 hours",
        },
        bindsOfThisDevice: "Automations with this device",
        noBindForThisDevice: "no automation",
        noVirtualDeviceInRemote: "no remote has been added to this device yet",
        lightLevels: [
            "Pitch Black",
            "ٰVery Dark",
            "Dark",
            "Normal Light",
            "Cozy Brightness",
            "Radiantly Brilliant",
            "Dazzling Brilliance",
        ],
        curtain: {
            open: "Open",
            opening: "Opening",
            close: "Close",
            closing: "Closing",
            tapToStop: "Tap to stop",
        },
        scenarioSwitchSectionTitle: {
            o: "Circle Key",
            x: "Cross Key",
            t: "Triangle Key",
            r: "Square Key",
        },
        scenarioSwitchSectionNotSpecified: "no scene is associated to this key",
        scenarioSwitchAssociatedScenario: "Select Scene",
        deviceSettings: {
            button: "Settings",
            name: "Name",
            edit: "Edit",
            save: "Save",
            color: "Color",
            useRoomColor: "Use room color",
            colors: {
                0: "Turquoise",
                1: "Forest",
                2: "Sky",
                3: "Ocean",
                4: "Royal purple",
                5: "Magenta",
                6: "Flamingo",
                7: "Fire red",
                8: "Tiger",
                9: "Canary",
                10: "Snow",
                11: "No color",
            },
            syncSettings: {
                header: "Synced Devices",
                info: {
                    none: "Not synced with any device",
                    main: "Syched as a main device",
                    follower: "Syched as a follower device",
                },
                hint: "All the main and follower devices will have a synced state, and can show or change it.",
                main: "Main Device",
                follower: "Follower Devices",
                edit1: "Edit Main Device",
                edit: "Edit Devices",
                editButtonExplaned: "Choose Follower Devices",
                editInfo: "Select all follower devices",
                removeSettings: "Delete This Settings",
                areYouSure: "Are you sure? The sync settings will be deleted and the devices will work independently.",
                deleteIt: "Delete it",
                keepIt: "No, Keep it",
            },
            sound: "Sound",
            soundInfo: "Play scene activation result sound",
            motionSensorSensitivity: "Sensor sensitivity",
            motionSensorSensitivityInfo: "High sensitivity (for lighting automations)",
            firmwareVersion: "Firmware version",
            firmwareIsLatest: "You have the latest version",
            firmwareNewVersion: "New version is available to install",
            firmwareTapToUpdate: "Tap to install the new update",
            switchNames: "Switch Names",
            switchNamesInfo: "Specifying switch names",
            channelNames: "Channel Names",
            channelNamesInfo: "Specifying channel names",
            refreshDuration: "Refresh duration",
            periodicRefresh: "Periodic refresh",
            periodicRefreshInfo: "Periodically refresh the air",
            durationBetweenRefreshes: "Duration between refreshes",
            musicInScenario: "Music in scenario",
            musicInScenarioInfo: "Use music in scenario",
            scenarioKey: "Scenario key",
            scenarioKeyInfo: "Activate scenario by touching lamp key",
            startingProcess: "Starting process",
            pumpDuration: "Pump Duration",
            startWithFastMode: "Start with fast mode",
            startFastAfterPump: "Start fast after pump",
            keepFastMode: "Keep fast mode",
            fastModeAsFinalState: "Fast mode as the final state",
            ringDuration: "Ring duration",
            elevatorLEDDuration: "Approximate duration of elevator arrival",
            curtainTime: "Open/Close duration",
            curtainTime1: "Open/Close duration of the 1st curtain",
            curtainTime2: "Open/Close duration of the 2nd curtain",
            degree: "degree",
            degrees: "degrees",
            millisecond: "millisecond",
            milliseconds: "milliseconds",
            second: "second",
            seconds: "seconds",
            minute: "minute",
            minutes: "minutes",
            percent: "percent",
            criticalBatteryLevel: "Critical Battery Level",
            envTemperatureCalibrationOffset: "Environment Temperature Calibration",
            turboSetPointOffset: "Turbo Set Point Offset",
            setpointHysteresis: "Hysteresis Offset From Setpoint",
            turboTimer: "Turbo Duration",
            keepOnAfterRebootH: "Power Outage",
            keepOnAfterReboot: "Keep State After Power Outage",
            showTemperatureWhenIsOffH: "Off Mode",
            showTemperatureWhenIsOff: "Show Temperature When Device Is Off",
            switchName1: "1st Switch Name",
            switchName2: "2nd Switch Name",
            switchName3: "3rd Switch Name",
            switchName4: "4th Switch Name",
            switchName1Default: "1st Switch",
            switchName2Default: "2nd Switch",
            switchName3Default: "3rd Switch",
            switchName4Default: "4th Switch",
            channelName1: "1st Channel Name",
            channelName2: "2nd Channel Name",
            channelName3: "3rd Channel Name",
            channelName4: "4th Channel Name",
            channelName1Default: "1st Channel",
            channelName2Default: "2nd Channel",
            channelName3Default: "3rd Channel",
            channelName4Default: "4th Channel",
        },
        power: {
            stat: "Power Stat",
            showReport: "Show reports",
            current: "Current Power",
            statistics: "Statistics",
            last1: "Last 24 Hours",
            last7: "Last 7 Days",
            last30: "Last Month",
            loading: "Fetching Data",
        },
        sirenState: {
            alarming: "Alarming",
            startAlarming: "Starting",
            notAlarming: "Ready",
        },
        thermostatOff: {
            title: "The device is OFF",
            button: "Turn the device On",
        },
        sedna: { // used in bind
            mode: "Mode",
            heating: "Heat",
            cooling: "Cool",
            fan: "Fan",

            fanSpeed: "Fan Speed",
            fast: "Fast",
            medium: "Medium",
            slow: "Slow",
            auto: "Auto",

            scene: "Preset States",
            turbo: "Turbo",
            leave: "Leave",
            manual: "Manual",
            sleep: "Sleep",
        },
        hinavaEcoThermostat: {
            mode: "Mode",
            heating: "Heat",
            cooling: "Cool",
            fan: "Fan",

            fanSpeed: "Fan Speed",
            fast: "Fast",
            medium: "Medium",
            slow: "Slow",
            auto: "Auto",

            turboHeader: "Turbo State",
            turbo: "Turbo",
            manual: "Manual",
        },
        marsus: {
            mode: {
                title: "Mode",
                heat: "Heat",
                cool: "Cool",
                auto: "Auto",
                manual: "Manual",
                normal: "Normal",
                antiFreeze: "Anti Freeze",
                eco: "Eco",
            },

            fanSpeed: {
                title: "Fan Speed",
                fast: "Fast",
                medium: "Medium",
                slow: "Slow",
                auto: "Auto",
                off: "Off",
            },

            pump: {
                title: "Water Pump",
                on: "On",
                off: "Off",
            },
        },
        addVirtualRemote: {
            button: "Add Remote",
            subtypes: {
                tv: "TV",
                split: "Air Conditioner"
            },
            selectSubType: "Select Remote Type",
            selectBrand: "Select The Brand",
            serachBrand: "Search the brand",
            fetchingData: "Fetching data",
            addingRemote: "Adding remote",
            noRemoteSupported: "This device does not support any of available remotes",
            noBrandFound: "no brand found",
            noIndexFound: "no remote found, please select another brand",
            retry: "Retry",
            errors: {
                1: "Device is not connected",
                2: "Operation is not permitted",
                3: "Gateway is not connected to the server",
                4: "Error from tuya server",
            },
            indexHint: "Please try to make sure that more than 3 buttons are working correctly",
            selectIndex: "Select this one",
            nextIndex: "Try next one",

            enterName: "Enter a name",
            deviceAddedInfo: "Remote has been added to your home successfully",
            name: "Name",
            youMustEnterAName: "You must enter a name for the remote",
            setName: "Done",
        },
        addDeviceProcess: {
            selectCategory: "Select Device Category",
            categories: {
                touchSwitches: "Touch Switches",
                securityDevices: "Security Devices",
                temperatureControlDevices: "Temperature Control Devices",
                electricityControlDevices: "Electricity Control Devices",
                convenienceDevices: "Convenience Devices",
            },
            selectType: "Select device type",
            types: {
                evaporativeCooler: "Evaporative Cooler",
                plug: "Smart Plug",
                door: "Door Sensor",
                motion: "Motion Sensor",
                thermostat: "Thermostat",
                hinavaEcoThermostat: "Titan Thermostat",
                sednaThermostat: "Sedna Thermostat",
                siren: "Siren",
                remote: "Remote Controller",
                tuyaPhysicalRemote: "Tuya Remote Controller",
                curtain: "Curtain",
                relay: "Relay Module",
                scenarioSwitch: "Scenario Switch",
                wc: "WC Switch",
                audioController: "Audio Controller",
                multipurposeSensor: "Multipurpose Sensor",
                doorbell: "Doorbell",
                elevator: "Elevator Switch",
            },
            selectSwitch: {
                categoryName: "Light Switch",
                selectPageTitle: "Select switch type",
                classicName: "Classic Switch",
                titanName: "Titan Switch",
                liteName: "Lite Switch",
            },
            selectDoor: {
                categoryName: "Door Sensor",
                selectPageTitle: "Select sensor type",
                bleName: "Classic BLE Sensor",
                wifiName: "Titan Wifi Sensor",
            },
            selectMotion: {
                categoryName: "Motion Sensor",
                selectPageTitle: "Select sensor type",
                bleName: "Classic BLE Sensor",
                wifiName: "Wifi Sensor",
            },
            status: {
                pairing: "Pairing",
                joined: "Successfully Added",
                connectionError: "Can’t connect to the device",
                unknownError: "Error in adding the device",
            },
            selectAll: "Add All Devices",
            pairingStatus: "Pairing Status",
            curtainSelectNumChannelsPageTitle: "Select number of channels",
            curtainOneChannel: "Control one curtain (one-channel)",
            curtainTwoChannels: "Control two curtains (two-channel)",
            resetDevicePageTitle: "Reset your device",
            connectNetwork: "Connect to WiFi network",
            wifiGHz: "Make sure your network has been set on 2.4GHz", // Only 2.4GHz Networks are available
            change: "Change",
            ssid: "Network Name (SSID)",
            ssidError: "Please enter network name",
            password: "Password",
            passwordError: "Please enter wifi password",
            next: "Next",
            setName: "Done",
            finish: "Done",
            searchingDevice: "Searching ...",
            searchBarText: "seconds to finish searching",
            searchBarText1: "second to finish searching",
            searchTipsHeader: "Make sure that ",
            searchTips: [
                {
                    selector: {
                        wifi: [true, false],
                        pluggable: [true],
                    },
                    text: "the device is plugged in",
                },
                {
                    selector: {
                        wifi: [true, false],
                        pluggable: [true, false],
                    },
                    text: "the device has been reset",
                },
                {
                    selector: {
                        wifi: [true],
                        pluggable: [true, false],
                    },
                    text: "the wifi password is entered correctly",
                },
                {
                    selector: {
                        wifi: [true, false],
                        pluggable: [true, false],
                    },
                    text: "the internet is connected",
                },
            ],
            selectDevice: "Select device",
            connecting: "Connecting",
            enterName: "Enter a name",
            deviceAddedInfo: "Device has been added to your home successfully",
            setScenarioSwitchConfigTitle: "Config Scene Switch",
            name: "Name",
            youMustEnterAName: "You must enter a name for the device", // also used in rename device
            retry: "Retry",
            errors: {
                "wifi_ssid_error_general": "Error in getting the connected wifi network information",
                "wifi_ssid_error_1": "Location permission is not granted in the hub",
                "wifi_not_connected": "Hub is not connected to wifi network",
                "not_found": "No device found for this device type",
                "another_search_in_progress": "Another search is in progress. Please wait 90 seconds and try again.",
                0: "Invalid network name",
                1: "Can not connect to the network",
                2: "Can not connect to the device",
                3: "Operation is not permitted",
                4: "Bluetooth permission is not granted in the hub",
                5: "Location permission is not granted in the hub",
                6: "Bluetooth is off, you should turn it on in the hub",
                7: "Location is off, you should turn it on in the hub",
                8: "The wifi password is not provided",
                9: "Device firmware need update. Please go to the hub and update the device",
                10: "Error interacting with the device"
            },
            espTouchInstruction1: `1- Install the EspTouch app.`,
            espTouchInstruction23: `2- In that app, select the EspTouch option and enter the WiFi information.\n3- Now the device status LED should turn orange.`,
            deviceLEDColorBecameOrange: "The device status LED turned orange",
            locationWarning: "If your hub is connected wirelessly (WiFi), enable location sensor access on the hub to automate this process. Using the Hinava Android client once will also automate this process.",
            esptouchHintToUseAndroidClient: "Using the Hinava Android client once will automate this process.",
            resetInstruction: {
                plug: '1- Plug in your device.\n2- Touch & Hold the front line for 5sec as you see in the picture.\n3- Device’s LED should blink in white for a short time.',
                audioController: '1- Plug in your device.\n2- Hold the "ON/OFF" button for 5sec.\n3- The "STATUS" LED should start blinking in cyan color.',
                classicSwitch: '1- Install your device and make sure the power is connected.\n2- Touch & Hold both switches with two fingers for 5sec.\n3- Switches and "Hinava" LEDs should blink in blue for a short time.',
                evaporativeCooler: '1- Install your device and make sure the power is connected.\n2- Touch & Hold the power and pump switches with two fingers for 5sec.\n3- Device will beep for the reset confirmation and "Hinava" will blink once.\n4- After 5 to 10 seconds, "Hinava" LED should start blinking fast in cyan color.',
                titanSwitch: '1- Install your device and make sure the power is connected.\n2- Touch & Hold the first two switches with two fingers for 5sec (hold first switch in 1-gang).\n3- Device will beep for the reset confirmation and "Hinava" will blink once.\n4- After 5 to 10 seconds, "Hinava" LED should start blinking fast in cyan color.',
                liteSwitch: '1- Install your device and make sure the power is connected.\n2- Touch & Hold the first two switches with two fingers for 5sec (hold first switch in 1-gang).\n3- Device will beep for the reset confirmation and the line LED will blink once.\n4- After 5 to 10 seconds, the line LED should start blinking fast in cyan color.',
                hinavaEcoThermostat: '1- Install your device and make sure the power is connected.\n2- Touch & Hold the mode and the fan buttons simultaneously with two fingers for 5sec.\n4- After 5 to 10 seconds, "Hinava" LED should start blinking fast in cyan color.',
                scenarioSwitch: '1- Install your device and make sure the power is connected.\n2- Touch & Hold the first two switches with two fingers for 5sec.\n3- Device will beep for the reset confirmation and "Hinava" will blink once.\n4- After 5 to 10 seconds, "Hinava" LED should start blinking fast in cyan color.',
                curtain: '1- Install your device and make sure the power is connected.\n2- Touch & Hold the first two switches with two fingers for 5sec.\n3- Device will beep for the reset confirmation and "Hinava" will blink once.\n4- After 5 to 10 seconds, "Hinava" LED should start blinking fast in cyan color.',
                relay: '1- Install your device and make sure the power is connected.\n2- Touch & Hold the first & the fourth buttons with two fingers for 5sec.\n3- After 5 to 10 seconds, the device\'s LED should start blinking fast in cyan color.',
                doorWifi: '1- Slide the device up & detach it from the wall.\n2- Make sure the power is connected.\n3- Press & Hold the white button above the battery for 5sec.\n4- Device’s front LED should blink in cyan color.',
                door: '1- Place the battery and make sure it\'s not empty.\n2- Press & Hold the white button near the battery for 5sec.\n3- Device’s LED should blink in white for a short time.',
                motion: '1- Place the battery and make sure it\'s not empty.\n2- Press & Hold the reset button (that is near the battery and inside the hole) with a pin for 5sec.\n3- Device’s LED should blink in white for a short time.',
                motionWifi: '1- Place the battery and make sure it\'s not empty.\n2- Press & Hold the reset button (that is near the battery and inside the hole) with a pin for 5sec.\n3- Device’s LED should start blinking fast in cyan color.',
                remote: '1- Plug in your device.\n2- Press & Hold the reset button (that is inside the hole) with a pin for 5sec as you see in the picture.\n3- Device’s LED should start blinking in cyan color.',
                siren: '1- Make sure the device battery is not empty.\n2- Unplug the device if it\'s pluged in.\n3- Press & Hold the reset button (that is inside the hole) with a pin for 5sec as you see in the picture.\n4- Device’s LED should start blinking fast in cyan color.',
                general: '1- Install the device and make sure the power is connected.\n2- Follow the instructions in the user manual to reset the device.',
            },
            resetInstructionConfirm: {
                blinkedLikeFigure: "Device blinked like the picture",
                blinkingLikeFigure: "Device is blinking like the figure",
                fastBlinkingLikeFigure: "Device is blinking fast",
                onReadyToSetupPhase: "Device is ready to setup now",
            },
        },
        removeDeviceConfirmAreYouSure: "Are you sure?",
        removeDeviceConfirmOK: "Delete it",
        removeDeviceConfirmNO: "No, Keep it",
        subRemotesOfThisRemote: "Remotes of this device",
        audioController: {
            currentPlaylist: "Current Playlist",
            currentPlaylistEmpty: "Current playlist is empty",
            currentPlaylistEdit: "Select music",
            modeIsNotHinava: "Device’s input is not the hinava hub",
            setHinavaMode: "Use hinava hub as input",
            deviceIsOff: "The audio controller is OFF",
            turnDeviceOn: "Turn the audio controller On",

            manage: "Manage",
            mode: "Input",
            modeHinava: "Hinava (Optical)",
            modeBluetooth: "Bluetooth",
            modeAUX: "Auxiliary (AUX)",
            modeHDMI: "HDMI",
            zones: "Zones",
            zone1: "Zone 1",
            zone2: "Zone 2",
            zone3: "Zone 3",
            zone4: "Zone 4",
            zoneEditNames: "Edit Names",
            zoneSaveNames: "Save names",

            chooseMusicList: "Choose Music List",
            folders: "Folders",
            albums: "Albums",
            track: "Track",
            tracks: "Tracks",
            reload: "Reload",
            chooseAndPlay: "Choose & Play",
            loadingData: "Loading Data",
            noMusicFound: "No Music Found",
            listDetailFunc: name => name + "’s Tracks"
        },
        wc: {
            inUse: "In Use",
            refreshing: "Refreshing",
            refresh: "Refresh",
        },

        // scenarios
        scenarios: "Scenes",
        noScenario: "No Scene",
        createScenarios: "Create Scene",
        runScenario: {
            titleHead: "running '",
            titleTail: "' scenario",
            gotIt: "Got it",
        },
        siriScenario: {
            titleFunc: (name) => "Integrating " + name + "\nwith Siri digital assistant",
            section1Text: "Copy the access key:",
            section1Button: "Copy access key",
            section2Text: "Click on the button below to open the Shortcuts app.\nThen, on the page that opens, click on the “Set Up Shortcut” button.\nAfter that, a page will open and you will be asked to paste the access key there.",
            section2Button: "Open Shortcuts",
            section3Text: "To use Siri digital assistant on a phone or smart watch, after activating Siri in the phone settings, you can turn on the assistant by saying “Hey Siri”.\nThen by saying the command “Run Hinava Scene”, Siri will run the scene.\nYou can also change the name of the voice command by renaming the Shortcut.",
            copied: "copied",
        },
        createScenarioProcess: {
            selectDevices: "Select Devices",
            selectDevicesInfo: "Select all Devices you want to use in this scene",
            next: "Next",
            selectBinds: "Select Automations",
            selectBindsInfo: "Select all Automations you want to use in this scene",
            setState: "Set State",
            set: "Set",
            enable: "Enable",
            disable: "Disable",
            sirenAlarming: "Alarming",
            sirenNotAlarming: "Not Alarming",

            // cooler, wc (used in bind)
            powerOn: "Power On",
            powerOff: "Power OFF",
            inUse: "In Use",
            refresh: "Refresh",
            setThisStateImmediately: "Set this state immediately",

            editScenario: "Edit Scene",
            overview: "Overview",
            backToOverview: "Back to Overview",
            youMustSelectADOB: "You must select at least one device or automation",
            devices: "Devices",
            noDevice: "no device is selected",
            binds: "Automations",
            noBind: "no automation is selected",
            delete: "Delete",
            areYouSure: "Are you sure?",
            deleteIt: "Delete it",
            keepIt: "No, Keep it",

            giveNameAndIcon: "Select name and icon",
            name: "Name",
            icon: "Icon",
            youMustEnterAName: "You must enter a name",
            create: "Create",
            edit: "Edit",
            namePlaceHolders: {
                1: "General",
                2: "Travel",
                3: "Movie",
                4: "Birthday",
                5: "Leave Home",
                6: "Enter Home",
                7: "Lights OFF",
                8: "Lights On",
                9: "Sleep",
            }
        },

        // logs
        logs: "Reports",
        noLogs: "No Reports",
        logIsRedacted: "More info is available for admin users",
        logSubjectF: {
            hub: "By Central Hub",
            general: "By {0}",
            bind: "By {0} Automation",
            scenario: "By {0} Scene",
        },
        logRefresh: {
            button: "Reload",
            instructionsPullToRefresh: 'Pull down to refresh',
            instructionsReleaseToRefresh: 'Release to refresh',
            instructionsRefreshing: 'Refreshing',
        },
        logFilter: {
            button: "Filter Reports",
            filteredBy: "Filtered by",
            filters: "Filters",
            filtersInfo: "By selecting the filters, make the reports more specific.",
            clear: "Clear",
            selectAll: "Select All",
            saveAndApply: "Save & Apply",
            time: {
                itemTitle: "Time",
                pageTitle: "Filter Time",
                pageInfo: "Select a time frame",
                noSelection: "no time frame selected",
                someSelection: count => count + " days selected",
                someSelectionSmall: count => count + " days",
                youMustEnterATimeFrame: "You must enter a time frame",
            },
            user: {
                itemTitle: "Users",
                pageTitle: "Filter Users",
                pageInfo: "Select your interested users to see the logs that are related to them",
                noSelection: "no users selected",
                someSelection: count => count + " users selected",
                someSelectionSmall: count => count + " users",
            },
            device: {
                itemTitle: "Devices",
                pageTitle: "Filter Devices",
                pageInfo: "Select your interested device to see the logs that are related to them",
                noSelection: "no device selected",
                someSelection: count => count + " device selected",
                someSelectionSmall: count => count + " device",
            },
            bind: {
                itemTitle: "Automations",
                pageTitle: "Filter Automations",
                pageInfo: "Select your interested automations to see the logs that are related to them",
                noSelection: "no automations selected",
                someSelection: count => count + " automations selected",
                someSelectionSmall: count => count + " automations",
            },
            scenario: {
                itemTitle: "Scenes",
                pageTitle: "Filter Scenes",
                pageInfo: "Select your interested scenes to see the logs that are related to them",
                noSelection: "no scenes selected",
                someSelection: count => count + " scenes selected",
                someSelectionSmall: count => count + " scenes",
            },
            room: {
                itemTitle: "Rooms",
                pageTitle: "Filter Rooms",
                pageInfo: "Select your interested rooms to see the logs that are related to them",
                noSelection: "no rooms selected",
                someSelection: count => count + " rooms selected",
                someSelectionSmall: count => count + " rooms",
            },
        },

        // insights & charts
        insightsSummary: {
            title: "Summary",
            detailedReports: "Detailed Reports",
            all: "All",
            door: c => (c > 1) ? "Door sensors" : "Door sensor",
            doors: "Door sensors",
            doorOpen: c => (c > 1) ? "are open" : "is open",
            doorsClosed: "are closed", // all
            motion: c => (c > 1) ? "Motion sensors" : "Motion sensor",
            motions: "Motion sensors",
            motionDetecting: c => (c > 1) ? "detect movement" : "detects movement",
            motionsIdle: "are idle", // all
            light: c => (c > 1) ? "Lights" : "Light",
            lights: "Lights",
            lightOn: c => (c > 1) ? "are On" : "is On",
            lightOff: "are OFF", // all
            automation: c => (c > 1) ? "Automations" : "Automation",
            automationTriggered: days => `triggered in the last ${days} day` + (days > 1 ? "s" : ""),
            scene: c => (c > 1) ? "Scenes" : "Scene",
            sceneRan: days => `ran in the last ${days} day` + (days > 1 ? "s" : ""),
            user: c => (c > 1) ? "Users" : "User",
            usersHaveAccess: c => (c > 1) ? "have access to the home" : "has access to the home",
            connectedDevice: c => (c > 1) ? "Connected devices" : "Connected device",
            disconnectedDevice: c => (c > 1) ? "Disconneced devices" : "Disconneced device",
            totalDevice: c => (c > 1) ? "Total\ndevices" : "Total\ndevice",
        },
        appReports: {
            title: "Application Reports",
            sourceOfChanges: days => `Source of changes in the devices, for the last ${days} day` + (days > 1 ? "s" : ""),
            percent: "% ",
            automations: "Automations",
            scenes: "Scenes",
            manual: "Manual",
            application: "Application",
            mostActiveUsers: (countOfUsers, days) => `The most active user${countOfUsers > 1 ? "s" : ""}, for the last ${days} day` + (days > 1 ? "s" : ""),
            visit: c => (c > 1) ? "Visits" : "Visit",
            command: c => (c > 1) ? "Commands" : "Command",
            comma: ",",
        },
        deviceReport: {
            title: "Device Reports",
            now: "Now",
            time: c => (c > 1) ? " times " : " time ",
            minute: c => (c > 1) ? "minutes " : "minute ",
            hour: c => (c > 1) ? "hours " : "hour ",
            opened: "opened",
            motionDetected: "motion detected",
            soundDetected: "sound detected",
            setPoint: "Set point",
            envTemperature: "Environment temperature",
            envHumidity: "Environment humidity",
            envLight: "Environment light",
            allLamps: "All Lamps",
            thisWeek: "this week",
            lastWeek: "last week",
            twoWeeksAgo: "two weeks ago",
            allLampsInfoPrefix: () => `The lamps of your home was On for the sum of `,
            allLampsInfoPostfix: hours => ` hour${hours > 1 ? "s" : ""} this week.`
        },

        // rooms
        myHome: "My Home",
        rooms: {
            roomManagement: "Room Management",
            rearrange: "Rearrange",
            rearrangeSave: "Save Arrangement",
            add: "Add Room",
            save: "Save",
            next: "Next",
            mustEnterAName: "You must enter a name for the room",
            notAny: "You don't have any room",
            settings: "Settings",
            chooseNameAndIcon: "Choose Name & Icon",
            name: "Name",
            namePlaceholder: "Room Name",
            icon: "Icon",
            color: "Color",
            removeAreYouSure: "Are you sure?",
            removeConfirmOK: "Delete it",
            removeConfirmNO: "No, Keep it",
            selectDevices: "Select Devices",
            selectDevicesInfo: "Select all devices you want to assign to the new room",
            editDevices: "Edit Devices",
            editDevicesInfo: "Select all devices you want to assign to this room",
            selectedDevices: "Selected Devices",
        },

        // setting
        settings: "Settings",
        profile: "Profile",
        language: "Language",
        change: "Change",
        advancedOptions: "Advanced Options",
        generalOptions: "General Options",
        about: "About",
        appSettings: "App Settings",
        homeManagement: "Home List",
        noHomeInList: "You aren't a member of any home yet",
        homeProfile: "Home Profile",
        clearData: "Sign Out & Clear Data",
        clearDataConfirmOK: "Clear All Data",
        clearDataConfirmNO: "No, Don't touch it!",
        clearDataConfirmAreYouSure: "Are you sure?",
        removeAllDevicesConfirmOK: "Delete All Devices",
        removeAllDevicesConfirmNO: "No, Keep them",
        removeAllDevicesConfirmAreYouSure: "Are you sure?",
        reload: "Reload the app",
        getPushPermission: "Get push notification permission",
        showSecondsInLog: "Show seconds in log",
        showDeleteAllDevicesButton: "Show the “Delete All Devices” button",
        enableDevTools: "Enable devtools",
        version: "version",
        staging: "staging",
        name: "Name",
        edit: "Edit",
        save: "Save",
        changeAvatar: "Change Avatar",
        selectAvatar: "Select Avatar",
        exitHome: "Exit",
        exitHomePopup: {
            header: "Are you sure you want to leave “{0}”?",
            onlyAdminInfo: "You are the only admin of this home and when you leave, the whole house and devices will also be removed for other users.",
            nonAdminInfo: "When you leave, this home remains available for other users.",
            adminInfo: "You are the admin of this home. If you select the “Leave & Delete” option, the entire home and devices will also be deleted for other users.",
            leave: "Leave", //  کاربر عادی + کاربر ادمین وقتی ادمین دیگه‌ای هم هست
            leaveAndDelete: "Leave & Delete", // تنها کاربر ادمین یا کاربر ادمین عادی
            no: "No, Keep it",
        },
        logoutSoloConfirmPopup: {
            header: "Are you sure you want to logout from solo cloud?",
            info: "You can access the solo homes after logging in again.",
            ok: "Logout from solo",
            no: "No, Keep them",
        },
        support: "Support",
        opensourceLicenses: "Open source licenses",
        clientVersion: "Client Software Version",
        clientVersionUpToDateInSetting: "Your client’s software is up to date.",
        hubVersion: "Hub Software Version",
        hubVersionUpToDateInSetting: "Your hub’s software is up to date.",
        newVersionInfo: "New version is available to install.",
        newVersionTapToUpdate: "Tap to install the new update",
        userManagement: {
            addUser: "Add User",
            addUserInfo: "Enter the user’s phone number to share the home",
            noName: "Not Specified",
            title: "User Management",
            homeUsers: "Home Users",
            pendingUsers: "Pending Users",
            pendingUsersInfo: "The following users have requested to add to the home, even though currently they don’t have any access.",
            detailTitleFormat: "{0}’s Profile",
            remove: "Remove",
            removeAreYouSure: "Are you sure?",
            removeConfirmOK: "Remove it",
            removeConfirmNO: "No, Keep it",
            noUser: "Use hub to add a new user.",
            notif: {
                title: "Notification",
                automations: "Automations Notification",
            },
            permissions: {
                title: "Permissions",
                admin: "Admin",
                deviceChangeState: "Change Device State",
                automationSettings: "Create & Remove Automation",
                automationEnable: "Disable & Enable Automation",
                sceneSettings: "Create & Remove Scene",
                sceneRun: "Run Scene",
            },
            adminAreYouSure: 'This will remove your "admin" permission. Are you sure?',
            adminConfirmRemove: "Remove it",
            adminConfirmKeep: "No, Keep it",
            adminCantRemoveAccessFromYourselfPopup: {
                header: "You're the only admin of this home",
                body: 'This will remove your "admin" permission. But you are the only admin of this home, So we can not do this operation.',
                ok: "Ok",
            },
        },
        multiOTA: {
            title: "Device firmware update",
            info: "These devices have newer versions available",
            nonAdminInfo: "These devices have newer versions available, Ask an admin user to update the device",
            updateAll: "Update All",
            update: "Update",
            nothingToOTA: "All online devices are up to date",
        },

        // binds
        binds: "Automations",
        noBind: "No Automation",
        updateHubToUseBind: "Update the hub’s application to use automations",
        createBinds: "Create Automation",
        bindText: {
            door: "Door",
            opened: "Opened",
            closed: "Closed",
            changed: "Changed",
            motion: "Motion",
            motionDetected: "Detected",
            motionStopped: "Stopped",
            temperature: "Temperature",
            humidity: "Humidity",
            lightLevel: "Light Level",
            sound: "Sound",
            soundDetected: "Detected",
            soundSilenced: "Silenced",
            alarmSection: "Alarm",
            alarming: "Alarming",
            silenced: "Stoped Alarming",
            batteryLevel: "Battery Level",
            batteryLevelBecameCritical: "Became Critical",
            powerPluged: "Power Connected",
            powerUnpluged: "Power Disconnected",
            alarm: "Start Alarming",
            silence: "Stop Alarming",
            power: "Power",
            turnedOn: "Turned On",
            turnOn: "Turn On",
            turnedOff: "Turned OFF",
            turnOff: "Turn OFF",
            change: "Change",
            open: "Open",
            close: "Close",
            wcScenario: "Refresh",
            lamp: "Lamp",
            fan: "Fan",
            spray: "Spray",
            music: "Music",
            inUse: "In Use",
            refresh: "Refresh",
            refreshed: "Refreshed",
            cancelRefresh: "Stop Refreshing",
            canceledRefresh: "Stoped Refreshing",
            ring: "Ring",
            callElevator: "Call",
            cancel: "Cancel",
            rang: "Rang",
            calledElevator: "Called",
            canceled: "Canceled",
            doSpray: "Spray",
            didSpray: "Sprayed",
            elevator: "Elevator",
            doorbell: "Doorbell",
            switch: "Switch",
            switch1: "1st Switch",
            switch2: "2nd Switch",
            switch3: "3rd Switch",
            switch4: "4th Switch",
            channel1: "1st Channel",
            channel2: "2nd Channel",
            channel3: "3rd Channel",
            channel4: "4th Channel",
            curtain: "Curtain",
            curtain1: "1st Curtain",
            curtain2: "2nd Curtain",
            alarmF: "Clock shows {0}",
            emailF: "Send email to {0}",
            smsF: "Text {0}",
            callF: "Call {0}",
            notif: "Send notification to the selected users",
            tvPowerToggle: "Toggle ON/OFF",
            tvMuteToggle: "Toggle Mute",
            tvSetChannelF: "Set channel number to {0}",
            splitStateF: "On | Mode: {0} | SetPoint: {1}°C | Fan Speed: {2}",
            splitState: {
                mode: {
                    heat: "Heat",
                    cool: "Cool",
                    dry: "Dry",
                    auto: "Auto",
                    fanOnly: "Fan Only",
                },
                fan: {
                    auto: "Auto",
                    x1: "Slow",
                    x2: "Medium",
                    x3: "Fast",
                },
            },
            coolerStateF: "{0} | Pump: {1} | Fan: {2}",
            coolerStates: {
                on: "On",
                off: "OFF",
                fast: "Fast",
                slow: "Slow"
            },
            hinavaEcoThermostatStateF: "On | Mode: {0} | SetPoint: {1}°C | Fan Speed: {2}",
            hinavaEcoThermostatStateTurboF: "On | Mode: {0} | SetPoint: {1}°C | Turbo",
            sednaStateF: "On | Mode: {0} | SetPoint: {1}°C | Fan Speed: {2} | Preset State: {3}",
            temperatureConditionF: {
                0: "Environment temperature: Dropped below {0}°C",
                1: "Environment temperature: Reaches {0}°C",
                2: "Environment temperature: Exceeded {0}°C",
            },
            humidityConditionF: {
                0: "Humidity: Dropped below {0}%",
                1: "Humidity: Reaches {0}%",
                2: "Humidity: Exceeded {0}%",
            },
            brighnessConditionF: {
                0: "Light Level: Dropped below “{0}”",
                1: "Light Level: Reaches “{0}”",
                2: "Light Level: Exceeded “{0}”",
            },
            coolerPowerSection: "Power",
            coolerPumpSection: "Pump",
            coolerFanSection: "Fan",
            didSetToSlow: "Set to Slow",
            didSetToFast: "Set to Fast",
            willSetToSlow: "Set to Slow",
            willSetToFast: "Set to Fast",
            run: "Run",
            scenarioNameF: "{0} Scene",
        },
        timezoneReset: "reset",
        timezoneStr: {
            "Asia/Tehran": "Iran",
            "Asia/Baghdad": "Iraq"
        },
        createBindProcess: {
            // main
            editAutomation: "Edit Automation",
            createAutomation: "Create Automation",
            createAutomationInfo: "Automations let you control your smart devices automatically in pre-defined conditions.",
            if: "IF  ",
            then: "Then  ",
            ifManyInfo: "(any of these conditions happened)",
            thenManyInfo: "(execute all of these tasks)",
            create: "Create",
            delete: "Delete",
            areYouSure: "Are you sure?",
            deleteIt: "Delete it",
            keepIt: "No, Keep it",
            addCondition: "Add Condition",
            addAnotherCondition: "Add Another Condition",
            noCondition: "Edit the automation to add a condition",
            addStatement: "Add Task",
            addAnotherStatement: "Add Another Task",
            noStatement: "Edit the automation to add a task",
            participatesInCycle: "This automation participates in a cycle.\nEdit your automations and remove the cycle.",
            setDelay: "Execution Delay",
            setDelayPageTitle: "Set Execution Delay",
            setDelayButton: "Set",
            setPeriod: "Effective Period",
            setPeriodPageTitle: "Set Effective Period",
            setPeriodButton: "Set",
            advancedOptions: "Advanced options",
            delay: "Delay",
            period: "Time Period",
            to: "To",
            to_: "to",
            clear: "Clear",
            name: "Name",
            namePlaceHolder: "Like ‘Home Security’ or ‘Making Tea’",
            youMustEnterAName: "You must enter a name for the automation",
            dayOfTheWeek: {
                title: "Day of the week",
                days: ["S", "S", "M", "T", "W", "T", "F"],
                daysLong: ["Saturday", "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
                allDays: "The automation can be triggered on any day.",
                selectiveDays: d => `The automation can only be triggered on ${d}.`,
                comma: ", ",
                and2: " and ",
                andM: ", and ",
                noday: "The automation cannot be triggered on any day of the week.",
                nodayEdit: "Edit the automation to select at least one day",
            },
            timezone: "Timezone",

            selectIfEventType: "Select the condition type",
            device: "Device",
            scenario: "Scene",
            time: "Schedule",

            selectStatementType: "Select the task type",
            call: "Call",
            sms: "SMS",
            notify: "Notification",
            email: "Email",

            selectDevice: "Select a device",
            selectScenario: "Select a scene",

            // chooseOneOfTheseStatements: "Choose one of these statements",

            whenTempIf: "IF Temperature",
            chooseOneOfTheseConditions: "Choose one of these conditions",
            whenConditionComparison: {
                lower: "is Lower than",
                equal: "is Equal to",
                higher: "is Higher than",
            },
            goToState: "Sets this state",

            whenTheClockShowsTheseNumbers: "Specify the execution time",
            chosseAddress: "Chosse Address",
            chosseNumber: "Chosse Number",
            youMustEnterAnAddress: "You must enter an address",
            youMustEnterANumber: "You must enter a number",
            phonenumber: "mobile or landline number",
            next: "Next",

            // also used in scenario
            tvToggleOnOff: "Toggle ON/OFF",
            tvMute: "Toggle Mute",
            tvChannelTitle: "Go to a channel",
            tvChannelLabel: "Channel Number",
            tvYouMustEnterANumber: "You must enter the channel number",
        },

        // messageCenter
        messageCenter: "Message Center",
        messageCenterLoadingText: "Loading message list",
        messageCenterCollapseText: "show less",
        messageCenterUncollapseText: "show more",

        // update notification
        updateNotification: {
            hubTitle: "Update hub’s software",
            clientTitle: "Update client’s app",
            changeHome: "Change home", // -from_handshake-
            gotIt: "Got it",
            update: "Update",
            later: "Later",
            criticalMessage: "You can not connect to your home because your hub’s software is out of date. Please update it.",
            message: "Your hub’s software is out of date. You can start the update remotely from the client.",
            clientMessage: "Your client’s app is out of date. You can start the update right now.",
            nonAdminMessage: "Your hub’s software is out of date. Please update its software.",
            nonOTAMessage: "Your hub’s software is out of date. Please refer to your hub and update its software.",
        },
        askPushPopup: {
            title: "Turn on notifications",
            body: "Get the most out of your smart home by staying up to date with what's happening.",
            allow: "Allow notifications",
            later: "Later"
        },
        availabilityPopup: {
            removed: {
                title: "This home is not available",
                body: "This house is unavailable and cannot be connected to."
            },
            offline: {
                title: "The central hub is offline",
                body: "Your central hub is offline. Please check the internet connection of the central hub. Attempts to connect to the central hub will continue in the background.",
            },
            shouldlogin: {
                title: "Re-login to Solo Cloud",
                body: "Your session is expired. Please log in again to Solo Cloud using your phone number and add the home to your list.",
            },
            changeHome: "Change home",
            ok: "Ok",
        },

        otaReport: {
            title: {
                downloading: "Downloading …", // + progress value
                installing: "Installing …", // + progress value
                done: "Done",
                error: "Error",
                formatTitleValue: (title, value) => `${title} ${value}%`,
            },
            infoGeneral: "Please be patient and don't turn off your device.\nYou can close this page or switch the app, the progress will continue in the background.",
            infoError: "Please try again and if it happened again, contact support.",
            infoDone: "Update completed successfully.",
        },

        aiChat: {
            listening: "Listening ...",
            thinking: "Thinking ...",
            clickToTalk: "Click to talk",
            errorNotAllowed: "Unfortunately this feature is not available for your device",
        },
    },
    fa: {
        // create profile
        yourProfileInThisHome: {
            header: "پروفایل شما در این خانه",
            info: "شما می‌توانید در خانه‌های متفاوت، پروفایل‌های متفاوتی داشته باشید",
            popupInfo: "برای استفاده از خانه لازم است که یک پروفایل بسازید.",
            popupButton: "ادامه دادن ساخت پروفایل",
        },
        homeProfilePage: {
            createHeader: "خانه جدید سولو",
            profleHeader: "پروفایل خانه",
            info: "یک خانه جدید سولو بسازید تا دستگاه‌های سولوی خود را در آن مدیریت کنید",
            changeAvatar: "تغییر آواتار خانه",
            homeNamePlaceholder: "نام خانه شما",
            create: "بساز",
        },
        welcome: "به هیناوا خوش‌ آمدید",
        addToHomeScreen: {
            header: "وب-اپلیکیشن هیناوا را به صفحه‌ی اصلی گوشی خود اضافه کنید",
            snooze: "متوجه شدم",
            messages: [
                <div className="text">۱ - روی دکمه‌ی <div className="share">Share</div> در نوار پایین کلیک کنید.</div>,
                <div className="text">۲ - در منوی باز شده، در قسمت پایین، گزینه‌ی <div className="add-text">Add to Home screen</div> را انتخاب کنید.</div>,
                <div className="text">۳ - در مرحله‌ی بعد در قسمت بالا روی <div className="add-button">Add</div> کلیک کنید.</div>
            ],
        },
        changeLanguage: "تغییر زبان",
        selectHomeTypeInfoPlease: "لطفا نوع خانه را انتخاب کنید",
        selectHomeTypeInfo: "نوع خانه را انتخاب کنید",
        homeType: {
            hub: "هاب",
            hubInfo: "اتصال به هاب مرکزی",
            solo: "سولو",
            soloInfo: "اتصال به دستگاه‌های بدون هاب",
        },
        namePlaceHolder: "نام شما",
        next: "بعدی",
        youMustEnterAName: "باید یک نام وارد کنید",

        // register home
        logoutSolo: "خروج از سولو",
        connectToHub: "به هاب مرکزی هیناوا متصل شوید",
        connectToHubInfo: "لطفا شماره‌ی تلفنی را که در مراحل ثبت‌نام هاب مرکزی استفاده کردید، وارد کنید",
        gatewayNumber: "شماره‌ی تلفن هاب مرکزی",
        connectToSolo: "شماره تلفن را وارد کنید",
        connectToSoloInfo: "لطفاً برای ورود به ابر سولو، شماره تلفن‌تان را وارد کنید",
        phoneNumber: "شماره تلفن",
        verificationCode: "وارد کردن کد تایید",
        verificationCodeInfoF: "لطفاً کد تایید ارسال شده به شماره تلفن {0} را وارد کنید",
        sendingVerificationCode: "ارسال کد تایید",
        verifyingTheCode: "در حال ورود",
        useSimulatedGateway: "از هاب شبیه‌سازی شده استفاده کن!",
        connectToGateway: "درحال اتصال به هاب مرکزی",
        tryAnotherHub: "به هاب دیگری متصل شوید",
        tryAnotherPhoneNumber: "تغییر شماره تلفن",
        waitingForAccept: "در انتظار تایید",
        waitingForAcceptInfo: "درخواست شما ارسال شده است. لطفا درخواست را در هاب تایید کنید.",
        youMustEnterAPN: "شما باید یک شماره‌ی تلفن وارد کنید",
        youMustEnterTheCode: "شما باید کد تایید را وارد کنید",
        loadingSoloHomes: "در حال دریافت اطلاعات خانه‌ها",
        creatingSoloHome: "ساخت خانه سولو",
        switchingSoloHome: "انتقال به خانه جدید سولو",
        resendCodeLimit: "کد تایید سه بار ارسال شده است",
        resendCode: "ارسال مجدد کد",
        resendCodeInfoF: "می‌توانید بعد از {0} ثانیه، کد را دوباره ارسال کنید",
        codeWasWrong: "کد وارد شده اشتباه بود",

        // home-tab
        home: "خانه",
        defaultHomeName: "خانه‌ی شما",
        addHome: "اضافه کردن خانه",

        // connection status
        statusConnecting: "در حال اتصال",
        statusUpdating: "دریافت اطلاعات",
        dataIsLoading: "در حال دریافت اطلاعات",
        statusStable: "اتصال پایدار",

        // devices
        devices: "دستگاه‌ها", // list header
        addDevice: "اضافه کردن دستگاه",
        deleteAllDevices: "حذف همه دستگاه‌ها",
        noDevice: "دستگاهی وجود ندارد",
        off: "خاموش",
        doorbell: {
            ringing: "در حال زنگ",
            tapToStop: "کلیک کنید تا متوقف شود",
        },
        elevator: {
            calling: "فراخوانی",
            tapToStop: "کلیک کنید تا متوقف شود",
        },
        pumpOff: "پمـپ",
        slowOff: "کــنـد",
        fastOff: "تند",
        closed: "بسته است",
        open: "باز است",
        motionDetected: "حرکت دیده شد",
        motionNotDetected: "حرکتی نیست",
        soundDetected: "صدایی شنیده شد",
        soundNotDetected: "بدون صدا",
        percentFunc: (v) => v + " درصد",
        cDegreeFunc: (v) => v + " درجه",
        noBatteryDetected: "باتری در دستگاه نیست",
        deviceConnected: "اتصال برقرار",
        deviceDC: "دستگاه متصل نیست", // in device list
        deviceDisonnected: "دستگاه متصل نیست", // in device detail
        reportsOfThisDevice: {
            label: "نمودار وضعیت دستگاه",
            smallerLabel: "برای ۲۴ ساعت اخیر",
        },
        bindsOfThisDevice: "لیست اگر-آنگاه‌های این دستگاه",
        noBindForThisDevice: "این دستگاه اگر-آنگاهی ندارد",
        noVirtualDeviceInRemote: "هنوز ریموتی به این دستگاه اضافه نشده است",
        lightLevels: [
            "تاریکی کامل",
            "خیلی تاریک",
            "کمی تاریک",
            "معمولی",
            "روشن",
            "خیلی روشن",
            "روشنایی کامل",
        ],
        curtain: {
            open: "باز شدن",
            opening: "در حال باز شدن",
            close: "بسته شدن",
            closing: "در حال بسته شدن",
            tapToStop: "کلیک کنید تا متوقف شود",
        },
        scenarioSwitchSectionTitle: {
            o: "کلید دایره",
            x: "کلید ضربدر",
            t: "کلید مثلث",
            r: "کلید مربع",
        },
        scenarioSwitchSectionNotSpecified: "سناریویی به این کلید متصل نشده است",
        scenarioSwitchAssociatedScenario: "انتخاب سناریو",
        deviceSettings: {
            button: "تنظیمات",
            name: "نام",
            edit: "ویرایش",
            save: "ذخیره",
            color: "رنگ",
            useRoomColor: "استفاده از رنگ اتاق",
            colors: {
                0: "فیروزه‌ای",
                1: "سبز جنگلی",
                2: "آبی آسمانی",
                3: "آبی اقیانوسی",
                4: "بنفش سلطنتی",
                5: "سرخابی",
                6: "صورتی فلامینگو",
                7: "قرمز آتشین",
                8: "پرتقالی",
                9: "زرد قناری",
                10: "سفیدِ برفی",
                11: "بدون رنگ",
            },
            syncSettings: {
                header: "دستگاه‌های همگام",
                info: {
                    none: "با هیچ دستگاهی همگام نشده است",
                    main: "همگام به عنوان دستگاه اصلی",
                    follower: "همگام به عنوان دستگاه پی‌رو",
                },
                hint: "تمامی دستگاه‌های پی‌رو و اصلی، وضعیت همگامی خواهند داشت و می‌توانند وضعیت را نشان داده و یا تغییر دهند.",
                main: "دستگاه اصلی",
                follower: "دستگاه‌های پی‌رو",
                edit1: "ویرایش دستگاه اصلی",
                edit: "ویرایش دستگاه‌ها",
                editButtonExplaned: "انتخاب دستگاه‌های پی‌رو",
                editInfo: "تمام دستگاه‌های پی‌رو را انتخاب کنید",
                removeSettings: "حذف تنظیمات",
                areYouSure: "آیا مطمئن هستید؟ تنظیمات دستگاه‌های همگام پاک شده و هر کدام مستقلاً عمل می‌کنند.",
                deleteIt: "پاک کن",
                keepIt: "نه، نگه‌ش دار",
            },
            sound: "صدا",
            soundInfo: "پخش شدن صدا برای اعلام نتیجه‌ی سناریو",
            motionSensorSensitivity: "حساسیت سنسور",
            motionSensorSensitivityInfo: "حساسیت بالا (استفاده برای اگر-آنگاه‌های روشنایی)",
            firmwareVersion: "نسخه‌ی نرم‌افزار دستگاه",
            firmwareIsLatest: "دستگاه به نسخه‌ی آخر به‌روز شده است",
            firmwareNewVersion: "نسخه‌ی جدید موجود و آماده‌ی نصب است",
            firmwareTapToUpdate: "برای بروزرسانی کلیک کنید",
            switchNames: "نام پل‌ها",
            switchNamesInfo: "انتخاب نام پل‌ها",
            channelNames: "نام کانال‌ها",
            channelNamesInfo: "انتخاب نام کانال‌ها",
            refreshDuration: "مدت زمان تازه‌سازی",
            periodicRefresh: "تازه‌سازی دوره‌ای",
            periodicRefreshInfo: "به صورت دوره‌ای تازه‌سازی انجام شود",
            durationBetweenRefreshes: "مدت زمان بین تازه‌سازی‌ها",
            musicInScenario: "موزیک در سناریو",
            musicInScenarioInfo: "تغییر موزیک با اجرای سناریو",
            scenarioKey: "دکمه‌ی سناریو",
            scenarioKeyInfo: "با لمس کردن دکمه‌ی چراغ، سناریو اجرا شود",
            startingProcess: "فرآیند روشن شدن",
            pumpDuration: "زمان روشن بودن پمپ",
            startWithFastMode: "شروع با فن تند",
            startFastAfterPump: "شروع با سرعت تند بعد از پمپ",
            keepFastMode: "نگه‌داشتن فن تند",
            fastModeAsFinalState: "سرعت تند به عنوان حالت نهایی",
            ringDuration: "مدت زمان زنگ زدن",
            elevatorLEDDuration: "زمان تقریبی رسیدن آسانسور",
            curtainTime: "زمان باز یا بسته شدن پرده",
            curtainTime1: "زمان باز یا بسته شدن پرده‌ی اول",
            curtainTime2: "زمان باز یا بسته شدن پرده‌ی دوم",
            degree: "درجه",
            degrees: "درجه",
            millisecond: "میلی‌ثانیه",
            milliseconds: "میلی‌ثانیه",
            second: "ثانیه",
            seconds: "ثانیه",
            minute: "دقیقه",
            minutes: "دقیقه",
            percent: "درصد",
            criticalBatteryLevel: "سطح بحرانی باتری",
            envTemperatureCalibrationOffset: "کالیبراسیون دمای محیط",
            turboSetPointOffset: "اختلاف دما در حالت توربو",
            setpointHysteresis: "اختلاف دماییِ بدون تغییر برای دمای هدف",
            turboTimer: "مدت زمان حالت توربو",
            keepOnAfterRebootH: "قطع و وصلی برق",
            keepOnAfterReboot: "حفظ حالت بعد از قطع و وصلی برق",
            showTemperatureWhenIsOffH: "حالت خاموش",
            showTemperatureWhenIsOff: "نمایش دما در حالت خاموش",
            switchName1: "نام پل اول",
            switchName2: "نام پل دوم",
            switchName3: "نام پل سوم",
            switchName4: "نام پل چهارم",
            switchName1Default: "پل اول",
            switchName2Default: "پل دوم",
            switchName3Default: "پل سوم",
            switchName4Default: "پل چهارم",
            channelName1: "نام کانال اول",
            channelName2: "نام کانال دوم",
            channelName3: "نام کانال سوم",
            channelName4: "نام کانال چهارم",
            channelName1Default: "کانال اول",
            channelName2Default: "کانال دوم",
            channelName3Default: "کانال سوم",
            channelName4Default: "کانال چهارم",
        },
        power: {
            stat: "توان مصرفی",
            showReport: "مشاهده‌ی گزارش",
            current: "توان مصرفی فعلی",
            statistics: "نمودار",
            last1: "۲۴ ساعت گذشته",
            last7: "هفت روز گذشته",
            last30: "یک ماه گذشته",
            loading: "در حال دریافت اطلاعات",
        },
        sirenState: {
            alarming: "در حال آژیر",
            startAlarming: "شروع",
            notAlarming: "آماده‌ی آژیر",
        },
        thermostatOff: {
            title: "دستگاه خاموش است",
            button: "روشن کردن دستگاه"
        },
        sedna: { // used in bind
            mode: "حالت",
            heating: "گرمایش",
            cooling: "سرمایش",
            fan: "فن",

            fanSpeed: "سرعت فن",
            fast: "تند",
            medium: "متوسط",
            slow: "کند",
            auto: "خودکار",

            scene: "حالت‌های پیش‌فرض",
            turbo: "توربو",
            leave: "خروج",
            manual: "دستی",
            sleep: "خواب",
        },
        hinavaEcoThermostat: {
            mode: "حالت",
            heating: "گرمایش",
            cooling: "سرمایش",
            fan: "فن",

            fanSpeed: "سرعت فن",
            fast: "تند",
            medium: "متوسط",
            slow: "کند",
            auto: "خودکار",

            turboHeader: "حالت توربو",
            turbo: "توربو",
            manual: "دستی",
        },
        marsus: {
            mode: {
                title: "حالت",
                heat: "گرمایش",
                cool: "سرمایش",
                auto: "اتوماتیک",
                manual: "دستی",
                normal: "معمولی",
                antiFreeze: "ضد یخ‌زدگی",
                eco: "اقتصادی",
            },

            fanSpeed: {
                title: "سرعت فن",
                fast: "تند",
                medium: "متوسط",
                slow: "کند",
                auto: "خودکار",
                off: "خاموش",
            },

            pump: {
                title: "پمپ آب",
                on: "روشن",
                off: "خاموش",
            },
        },
        addVirtualRemote: {
            button: "ریموت جدید",
            subtypes: {
                tv: "تلویزیون",
                split: "کولر گازی"
            },
            selectSubType: "انتخاب نوع ریموت",
            selectBrand: "انتخاب برند",
            serachBrand: "جست و جوی برند",
            fetchingData: "در حال دریافت اطلاعات",
            addingRemote: "در حال اضافه کردن ریموت",
            noRemoteSupported: "این دستگاه هیچ‌کدام از ریموت‌های در دسترس را پشتیبانی نمی‌کند",
            noBrandFound: "برندی یافت نشد",
            noIndexFound: "ریموتی یافت نشد، لطفاً یک برند دیگر را انتخاب کنید",
            retry: "تلاش مجدد",
            errors: {
                1: "دستگاه متصل نیست",
                2: "اجازه‌ی انجام قسمتی از فعالیت‌ها را ندارید",
                3: "هاب مرکزی به سرور متصل نیست",
                4: "خطا از سرور تویا",
            },
            indexHint: "لطفاً سعی کنید ریموتی را انتخاب کنید که بیشتر از سه دکمه‌ی آن درست کار کند",
            selectIndex: "انتخاب این ریموت",
            nextIndex: "امتحان کردن ریموت بعدی",

            enterName: "انتخاب نام ریموت",
            deviceAddedInfo: "ریموت با موفقیت به خانه‌ی شما اضافه شد",
            name: "نام",
            youMustEnterAName: "باید یک نام برای ریموت وارد کنید",
            setName: "تایید",
        },
        addDeviceProcess: {
            selectCategory: "انتخاب دسته‌بندی دستگاه",
            categories: {
                touchSwitches: "کلید‌های لمسی",
                securityDevices: "دستگاه‌های امنیتی",
                temperatureControlDevices: "کنترل دما",
                electricityControlDevices: "کنترل برق",
                convenienceDevices: "دستگاه‌های راحتی",
            },
            selectType: "انتخاب نوع دستگاه",
            types: {
                evaporativeCooler: "کولر آبی",
                plug: "پریز هوشمند",
                door: "سنسور در",
                motion: "سنسور حرکت",
                thermostat: "ترموستات",
                hinavaEcoThermostat: "ترموستات تیتان",
                sednaThermostat: "ترموستات سدنا",
                siren: "آژیر",
                remote: "ریموت کنترلر",
                tuyaPhysicalRemote: "ریموت کنترلر تویا",
                curtain: "پرده برقی",
                relay: "ماژول رله",
                scenarioSwitch: "کلید سناریو",
                wc: "کلید سرویس بهداشتی",
                audioController: "کنترل‌کننده موسیقی",
                multipurposeSensor: "سنسور چندمنظوره",
                doorbell: "زنگ در",
                elevator: "کلید آسانسور",
            },
            selectSwitch: {
                categoryName: "کلید روشنایی",
                selectPageTitle: "انتخاب نوع کلید",
                classicName: "کلید کلاسیک",
                titanName: "کلید تیتان",
                liteName: "کلید لایت"
            },
            selectDoor: {
                categoryName: "سنسور در و پنجره",
                selectPageTitle: "انتخاب نوع سنسور",
                bleName: "سنسور کلاسیک بلوتوثی",
                wifiName: "سنسور تیتان وای‌فایی",
            },
            selectMotion: {
                categoryName: "سنسور حرکت",
                selectPageTitle: "انتخاب نوع سنسور",
                bleName: "سنسور کلاسیک بلوتوثی",
                wifiName: "سنسور وای‌فایی",
            },
            status: {
                pairing: "در حال اتصال",
                joined: "با موفقیت اضافه شد",
                connectionError: "خطا در اتصال به دستگاه",
                unknownError: "خطا در اضافه کردن دستگاه",
            },
            selectAll: "انتخاب همه",
            pairingStatus: "وضعیت اتصال",
            curtainSelectNumChannelsPageTitle: "انتخاب تعداد پرده",
            curtainOneChannel: "کنترل یک پرده (تک کاناله)",
            curtainTwoChannels: "کنترل دو پرده (دو کاناله)",
            resetDevicePageTitle: "دستگاه را به تنظیمات کارخانه برگردانید",
            connectNetwork: "اتصال به شبکه‌ی WiFi",
            wifiGHz: "مطمئن شوید شبکه‌ی شما روی فرکانس 2.4GHz تنظیم شده است",
            change: "تغییر",
            ssid: "نام شبکه (SSID)",
            ssidError: "لطفا نام شبکه را وارد کند",
            password: "رمز شبکه",
            passwordError: "لطفا رمز شبکه را وارد کند",
            next: "بعدی",
            setName: "تایید",
            finish: "پایان",
            searchingDevice: "در حال جستجو ...",
            searchBarText: "ثانیه تا پایان جستجو",
            searchBarText1: "ثانیه تا پایان جستجو",
            searchTipsHeader: "مطمئن شوید که ",
            searchTips: [
                {
                    selector: {
                        wifi: [true, false],
                        pluggable: [true],
                    },
                    text: "دستگاه به برق متصل است",
                },
                {
                    selector: {
                        wifi: [true, false],
                        pluggable: [true, false],
                    },
                    text: "دستگاه درست reset شده است",
                },
                {
                    selector: {
                        wifi: [true],
                        pluggable: [true, false],
                    },
                    text: "رمز شبکه را به درستی وارد کرده اید",
                },
                {
                    selector: {
                        wifi: [true, false],
                        pluggable: [true, false],
                    },
                    text: "اینترنت شما وصل است",
                },
            ],
            selectDevice: "انتخاب دستگاه",
            connecting: "در حال اتصال",
            enterName: "انتخاب نام دستگاه",
            deviceAddedInfo: "دستگاه با موفقیت به خانه‌ی شما اضافه شد",
            setScenarioSwitchConfigTitle: "تنظیم کلید سناریو",
            name: "نام",
            youMustEnterAName: "باید یک نام برای دستگاه وارد کنید", // also used in rename device
            retry: "تلاش مجدد",
            errors: {
                "wifi_ssid_error_general": "خطا در گرفتن اطلاعات شبکه",
                "wifi_ssid_error_1": "اجازه‌ی استفاده از سنسور مکان‌یابی به هاب داده نشده است",
                "wifi_not_connected": "هاب به شبکه‌ی وای‌فای متصل نیست",
                "not_found": "هیچ دستگاهی از این نوع پیدا نشد",
                "another_search_in_progress": "جستجوی دیگری در حال انجام است. لطفاً ۹۰ ثانیه صبر کنید و دوباره تلاش کنید.",
                0: "نام شبکه نامعتبر است",
                1: "خطا در اتصال به شبکه",
                2: "خطا در اتصال به دستگاه",
                3: "اجازه‌ی انجام قسمتی از فعالیت‌ها را ندارید",
                4: "اجازه‌ی استفاده از بلوتوث به هاب داده نشده است",
                5: "اجازه‌ی استفاده از سنسور مکان‌یابی به هاب داده نشده است",
                6: "بلوتوث خاموش است، لطفا آن را در هاب روشن کنید",
                7: "سنسور مکان‌یابی خاموش است، لطفا آن را در هاب روشن کنید",
                8: "رمز شبکه وارد نشده است",
                9: "دستگاه نیاز به بروزرسانی دارد. لطفاً با مراجعه به هاب، دستگاه را بروزرسانی کنید",
                10: "خطا در تعامل با دستگاه",
            },
            espTouchInstruction1: `۱- برنامه‌ی EspTouch را نصب کنید.`,
            espTouchInstruction23: `۲- در آن برنامه با انتخاب گزینه‌ی EspTouch اطلاعات وای‌فای را وارد کنید.\n۳- حالا رنگ چراغ دستگاه باید نارنجی شود.`,
            deviceLEDColorBecameOrange: "رنگ چراغ دستگاه نارنجی شد",
            locationWarning: "اگر هاب شما به صورت بی‌سیم (وای‌فای) وصل است، اجازه‌ی استفاده از سنسور مکان‌یابی را در هاب فعال کنید تا این فرآیند اتوماتیک شود. یکبار استفاده از کلاینت اندروید هیناوا نیز این فرایند را اتوماتیک می‌کند.",
            esptouchHintToUseAndroidClient: "یکبار استفاده از کلاینت اندروید هیناوا این فرایند را اتوماتیک می‌کند.",
            resetInstruction: {
                plug: `۱- دستگاه را به برق بزنید.\n۲- مطابق شکل، خط برآمدگی روی دستگاه را با کل انگشت به مدت حداقل پنج ثانیه لمس کرده و نگه‌دارید.\n۳- حالا دستگاه باید چند چشمک سفید بزند.`,
                audioController: '۱- دستگاه را به برق بزنید.\n۲- دکمه‌ی ON/OFF را به مدت ۵ ثانیه نگه دارید.\n۳- حال چراغ STATUS باید به رنگ آبی شروع به چشمک زدن بکند.',
                classicSwitch: `۱- دستگاه را نصب کرده و مطمئن شوید برق ورودی دستگاه متصل است.\n۲- مطابق شکل، با دو انگشت دو پل دستگاه را لمس کرده و حداقل به مدت پنج ثانیه نگه‌دارید.\n۳- حالا پل‌ها و نوشته‌ی Hinava باید چند بار به رنگ آبی چشمک بزنند.`,
                evaporativeCooler: `۱- دستگاه را نصب کرده و مطمئن شوید برق ورودی دستگاه متصل است.\n۲- مطابق شکل، با دو انگشت کلید‌های «پمپ» و «روشن» را لمس کرده و حداقل به مدت پنج ثانیه نگه‌دارید.\n۳- نوشته‌ی Hinava یک بار چشمک زده و دستگاه بوق reset را پخش می‌کند.\n۴- بعد از پنج الی ده ثانیه، نوشته‌ی Hinava به حالت چشمک فیروزه‌ای سریع می‌رود (دو بار در ثانیه).`,
                titanSwitch: `۱- دستگاه را نصب کرده و مطمئن شوید برق ورودی دستگاه متصل است.\n۲- مطابق شکل، با دو انگشت دو پل اول دستگاه را لمس کرده و حداقل به مدت پنج ثانیه نگه‌دارید (برای کلید تک‌پل فقط کلید اول را نگه دارید).\n۳- نوشته‌ی Hinava یک بار چشمک زده و دستگاه بوق reset را پخش می‌کند.\n۴- بعد از پنج الی ده ثانیه، نوشته‌ی Hinava به حالت چشمک فیروزه‌ای سریع می‌رود (دو بار در ثانیه).`,
                liteSwitch: `۱- دستگاه را نصب کرده و مطمئن شوید برق ورودی دستگاه متصل است.\n۲- مطابق شکل، با دو انگشت دو پل اول دستگاه را لمس کرده و حداقل به مدت پنج ثانیه نگه‌دارید (برای کلید تک‌پل فقط کلید اول را نگه دارید).\n۳- مطابق شکل خط زیر پل‌ها یک بار چشمک زده و دستگاه بوق reset را پخش می‌کند.\n۴- بعد از پنج الی ده ثانیه، خط زیر پل‌ها به حالت چشمک فیروزه‌ای سریع می‌رود (دو بار در ثانیه).`,
                hinavaEcoThermostat: `۱- دستگاه را نصب کرده و مطمئن شوید برق ورودی دستگاه متصل است.\n۲- مطابق شکل، با دو انگشت دکمه‌های فن و مود را به طور همزمان لمس کرده و حداقل به مدت پنج ثانیه نگه‌دارید.\n۴- بعد از پنج الی ده ثانیه، نوشته‌ی Hinava به حالت چشمک فیروزه‌ای سریع می‌رود (دو بار در ثانیه).`,
                scenarioSwitch: `۱- دستگاه را نصب کرده و مطمئن شوید برق ورودی دستگاه متصل است.\n۲- مطابق شکل، با دو انگشت دو کلید اول دستگاه را لمس کرده و حداقل به مدت پنج ثانیه نگه‌دارید.\n۳- نوشته‌ی Hinava یک بار چشمک زده و دستگاه بوق reset را پخش می‌کند.\n۴- بعد از پنج الی ده ثانیه، نوشته‌ی Hinava به حالت چشمک فیروزه‌ای سریع می‌رود (دو بار در ثانیه).`,
                curtain: `۱- دستگاه را نصب کرده و مطمئن شوید برق ورودی دستگاه متصل است.\n۲- مطابق شکل، با دو انگشت دو کلید اول دستگاه را لمس کرده و حداقل به مدت پنج ثانیه نگه‌دارید.\n۳- نوشته‌ی Hinava یک بار چشمک زده و دستگاه بوق reset را پخش می‌کند.\n۴- بعد از پنج الی ده ثانیه، نوشته‌ی Hinava به حالت چشمک فیروزه‌ای سریع می‌رود (دو بار در ثانیه).`,
                relay: `۱- دستگاه را نصب کرده و مطمئن شوید برق ورودی دستگاه متصل است.\n۲- مطابق شکل، به طور همزمان کلید‌ اول و چهارم دستگاه را لمس کرده و حداقل به مدت پنج ثانیه نگه‌دارید.\n۳- بعد از پنج الی ده ثانیه، چراغ مشخص شده به حالت چشمک فیروزه‌ای سریع می‌رود (دو بار در ثانیه).`,
                doorWifi: `۱-دستگاه را به طور کشویی بالا کشیده و از دیوار جدا کنید.\n۲-مطمئن شوید که دستگاه به برق متصل است.\n۳- دکمه‌ی سفید‌رنگ بالای باتری را، مطابق شکل، با یک جسم نوک‌تیز حداقل پنج ثانبه فشار داده و نگه‌دارید.\n۴- حالا چراغ جلوی دستگاه باید چشمک فیروزه‌ای بزند.`,
                door: `۱- باتری را در دستگاه گذاشته و مطمئن شوید که باتری خالی نباشد.\n۲- دکمه‌ی سفید‌رنگ کنار باتری را، مطابق شکل، حداقل پنج ثانبه فشار داده و نگه‌دارید.\n۳- حالا چراغ دستگاه باید چندبار چشمک سفید بزند.`,
                motion: `۱- باتری را در دستگاه گذاشته و مطمئن شوید که باتری خالی نباشد.\n۲- مطابق شکل، با یک شیء نوک‌‌تیز دکمه‌ی reset را (که کنار باتری و داخل حفره تعبیه شده است) فشار داده و حداقل به مدت پنج ثانیه نگه‌دارید.\n۳- حالا چراغ دستگاه باید چندبار چشمک سفید بزند.`,
                motionWifi: `۱- باتری را در دستگاه گذاشته و مطمئن شوید که باتری خالی نباشد.\n۲- مطابق شکل، با یک شیء نوک‌‌تیز دکمه‌ی reset را (که کنار باتری و داخل حفره تعبیه شده است) فشار داده و حداقل به مدت پنج ثانیه نگه‌دارید.\n۳- حالا چراغ دستگاه به حالت چشمک فیروزه‌ای سریع می‌رود (دو بار در ثانیه).`,
                siren: `۱- مطمئن شوید که باتری دستگاه شارژ دارد.\n۲- اگر دستگاه در برق است، آن را خارج کنید.\n۳- مطابق شکل، با یک شیء نوک‌تیز دکمه‌ی reset را (که درون حفره است) فشار داده و حداقل به مدت پنج ثانیه نگه‌دارید.\n۴- حالا چراغ دستگاه به حالت چشمک سریع می‌رود (دو بار در ثانیه).`,
                remote: `۱- دستگاه را به برق بزنید.\n۲- مطابق شکل، با یک شیء نوک‌تیز دکمه‌ی reset را (که درون حفره است) فشار داده و حداقل به مدت پنج ثانیه نگه‌دارید.\n۳- حالا مطابق شکل، چراغ دستگاه به حالت چشمک فیروزه‌ای می‌رود.`,
                general: `۱- دستگاه را نصب کرده و مطمئن شوید برق ورودی دستگاه متصل است.\n۲- مطابق دستورات دفترچه‌ی راهنما، دستگاه را reset کرده و یا «در حالت آماده به تنظیم» ببرید.`,
            },
            resetInstructionConfirm: {
                blinkedLikeFigure: "دستگاه مطابق شکل چشمک زد",
                blinkingLikeFigure: "دستگاه مطابق شکل چشمک می‌زند",
                fastBlinkingLikeFigure: "دستگاه در حال چشمک سریع است",
                onReadyToSetupPhase: "دستگاه در حالت «آماده به تنظیم» است",
            },
        },
        removeDeviceConfirmAreYouSure: "از پاک کردن دستگاه مطمئن هستید؟",
        removeDeviceConfirmOK: "پاک کن",
        removeDeviceConfirmNO: "نه، نگه‌ش دار",
        subRemotesOfThisRemote: "لیست ریموت‌های این دستگاه",
        audioController: {
            currentPlaylist: "لیست پخش فعلی",
            currentPlaylistEmpty: "لیست پخش خالی است",
            currentPlaylistEdit: "انتخاب آهنگ",
            modeIsNotHinava: "ورودی پخش‌کننده، هاب هیناوا نیست",
            setHinavaMode: "تنظیم ورودی به هیناوا",
            deviceIsOff: "کنترل‌کننده‌ی موسیقی خاموش است",
            turnDeviceOn: "روشن کردن کنترل‌کننده‌ی موسیقی ",

            manage: "مدیریت",
            mode: "ورودی",
            modeHinava: "هیناوا (اپتیکال)",
            modeBluetooth: "بلوتوث",
            modeAUX: "آگزیلیری (AUX)",
            modeHDMI: "HDMI",
            zones: "ناحیه‌ها",
            zone1: "ناحیه‌ی ۱",
            zone2: "ناحیه‌ی ۲",
            zone3: "ناحیه‌ی ۳",
            zone4: "ناحیه‌ی ۴",
            zoneEditNames: "تغییر نام",
            zoneSaveNames: "ذخیره‌ی نام",

            chooseMusicList: "انتخاب لیست موسیقی",
            folders: "پوشه‌ها",
            albums: "آلبوم‌ها",
            track: "Track",
            tracks: "Tracks",
            reload: "تازه‌سازی",
            chooseAndPlay: "انتخاب و پخش",
            loadingData: "درحال دریافت اطلاعات",
            noMusicFound: "هیچ آهنگی پیدا نشد",
            listDetailFunc: name => "آهنگ‌های " + name,
        },
        wc: {
            inUse: "در حال استفاده",
            refreshing: "تازه‌سازی",
            refresh: "تازه‌سازی",
        },

        // scenarios
        scenarios: "سناریو‌ها",
        noScenario: "سناریویی وجود ندارد",
        createScenarios: "سناریو جدید",
        runScenario: {
            titleHead: "اجرای سناریوی «",
            titleTail: "»",
            gotIt: "باشه",
        },
        siriScenario: {
            titleFunc: (name) => "اتصال سناریوی " + name + "\nبه دستیار صوتی Siri",
            section1Text: "کلید دسترسی را کپی کنید:",
            section1Button: "کپی کلید دسترسی",
            section2Text: "بر روی دکمه‌ی زیر کلیک کنید تا برنامه‌ی Shortcuts باز شود.\nسپس در صفحه‌ی باز شده، بر روی دکمه‌ی Set Up Shortcut کلیک کنید.\nبعد از آن، صفحه‌ای باز می‌شود و از شما خواسته می‌شود تا کلید دسترسی را در آنجا جایگذاری (paste) کنید.",
            section2Button: "ورود به Shortcuts",
            section3Text: "برای استفاده از دستیار صوتی هوشمند Siri بر روی گوشی یا ساعت هوشمند، بعد از فعال‌سازی Siri در تنظیمات گوشی، می‌توانید با گفتن عبارت «Hey Siri» دستیار را روشن کنید.\nسپس با بیان فرمان «Run Hinava Scene»، سناریوی مد نظر شما اجرا می‌شود.\nهمچنین می‌توانید با تغییر نام Shortcut، نام فرمان صوتی را نیز تغییر دهید.",
            copied: "کپی شد",
        },
        createScenarioProcess: {
            selectDevices: "انتخاب دستگاه‌ها",
            selectDevicesInfo: "دستگاه‌هایی را که می‌خواهید در این سناریو باشند، انتخاب کنید",
            next: "بعدی",
            selectBinds: "انتخاب اگر-آنگاه‌ها",
            selectBindsInfo: "اگر-آنگاه‌هایی را که می‌خواهید در این سناریو باشند، انتخاب کنید",
            setState: "تعیین حالت دستگاه",
            set: "تایید",
            enable: "فعال",
            disable: "غیرفعال",
            sirenAlarming: "آژیر زدن",
            sirenNotAlarming: "قطع آژیر",

            // cooler, wc (used in bind)
            powerOn: "روشن شود",
            powerOff: "خاموش شود",
            inUse: "در حال استفاده",
            refresh: "تازه‌سازی",
            setThisStateImmediately: "درجا به این حالت برود",

            editScenario: "ویرایش سناریو",
            overview: "نمای کلی سناریو",
            backToOverview: "بازگشت به نمای کلی",
            youMustSelectADOB: "برای ادامه باید حداقل یک دستگاه یا اگر-آنگاه انتخاب کرده باشید",
            devices: "دستگاه‌ها",
            noDevice: "دستگاهی انتخاب نشده است",
            binds: "اگر-آنگاه‌ها",
            noBind: "اگر-آنگاهی انتخاب نشده است",
            delete: "پاک کردن",
            areYouSure: "آیا مطمئن هستید؟",
            deleteIt: "پاک کن",
            keepIt: "نه، نگه‌ش دار",

            giveNameAndIcon: "انتخاب نام و شکل سناریو",
            name: "نام",
            icon: "شکل",
            youMustEnterAName: "باید یک نام وارد کنید",
            create: "بساز",
            edit: "ویرایش",
            namePlaceHolders: {
                1: "عمومی",
                2: "مسافرت",
                3: "تماشای فیلم",
                4: "جشن تولد",
                5: "خروج از خانه",
                6: "ورود به خانه",
                7: "خاموشی",
                8: "روشنایی",
                9: "خواب",
            }
        },

        // logs
        logs: "گزارش‌ها",
        noLogs: "گزارشی وجود ندارد",
        logIsRedacted: "اطلاعات بیشتر برای کاربران ادمین قابل مشاهده است",
        logSubjectF: {
            hub: "توسط هاب مرکزی",
            general: "توسط {0}",
            bind: "توسط اگر-آنگاه {0}",
            scenario: "توسط سناریو {0}",
        },
        logRefresh: {
            button: "تازه‌سازی",
            instructionsPullToRefresh: 'بکشید تا بروزرسانی شود',
            instructionsReleaseToRefresh: 'رها کنید تا بروزرسانی شود',
            instructionsRefreshing: 'در حال بروزرسانی',
        },
        logFilter: {
            button: "فیلتر کردن گزارش‌ها",
            filteredBy: "فیلتر شده با",
            filters: "فیلتر‌ها",
            filtersInfo: "با انتخاب فیلتر‌های زیر، گزارش‌ها را محدودتر کنید.",
            clear: "پاک کردن",
            selectAll: "انتخاب همه",
            saveAndApply: "ذخیره و اعمال",
            time: {
                itemTitle: "زمان",
                pageTitle: "فیلتر کردن زمان",
                pageInfo: "یک بازه‌ی زمانی را انتخاب کنید",
                noSelection: "بازه زمانی‌ای انتخاب نشده است",
                someSelection: count => count + " روز انتخاب شده است",
                someSelectionSmall: count => count + " روز",
                youMustEnterATimeFrame: "باید یک بازه زمانی انتخاب کنید",
            },
            user: {
                itemTitle: "کاربران",
                pageTitle: "فیلتر کردن کاربران",
                pageInfo: "کاربران مورد نظر خود را انتخاب کنید تا گزارش‌های مربوط به آن‌ها را مشاهده کنید",
                noSelection: "کاربری انتخاب نشده است",
                someSelection: count => count + " کاربر انتخاب شده است",
                someSelectionSmall: count => count + " کاربر",
            },
            device: {
                itemTitle: "دستگاه‌ها",
                pageTitle: "فیلتر کردن دستگاه‌ها",
                pageInfo: "دستگاه‌های مورد نظر خود را انتخاب کنید تا گزارش‌های مربوط به آن‌ها را مشاهده کنید",
                noSelection: "دستگاهی انتخاب نشده است",
                someSelection: count => count + " دستگاه انتخاب شده است",
                someSelectionSmall: count => count + " دستگاه",
            },
            bind: {
                itemTitle: "اگر-آنگاه‌ها",
                pageTitle: "فیلتر کردن اگر-آنگاه‌ها",
                pageInfo: "اگر-آنگاه‌های مورد نظر خود را انتخاب کنید تا گزارش‌های مربوط به آن‌ها را مشاهده کنید",
                noSelection: "اگر-آنگاهی انتخاب نشده است",
                someSelection: count => count + " اگر-آنگاه انتخاب شده است",
                someSelectionSmall: count => count + " اگر-آنگاه",
            },
            scenario: {
                itemTitle: "سناریو‌ها",
                pageTitle: "فیلتر کردن سناریو‌ها",
                pageInfo: "سناریو‌های مورد نظر خود را انتخاب کنید تا گزارش‌های مربوط به آن‌ها را مشاهده کنید",
                noSelection: "سناریویی انتخاب نشده است",
                someSelection: count => count + " سناریو انتخاب شده است",
                someSelectionSmall: count => count + " سناریو",
            },
            room: {
                itemTitle: "اتاق‌ها",
                pageTitle: "فیلتر کردن اتاق‌ها",
                pageInfo: "اتاق‌های مورد نظر خود را انتخاب کنید تا گزارش‌های مربوط به آن‌ها را مشاهده کنید",
                noSelection: "اتاقی انتخاب نشده است",
                someSelection: count => count + " اتاق انتخاب شده است",
                someSelectionSmall: count => count + " اتاق",
            },
        },

        // insights & charts
        insightsSummary: {
            title: "خلاصه",
            detailedReports: "گزارش‌های تکمیلی",
            all: "همه",
            door: () => "سنسور در",
            doors: "سنسور‌های در",
            doorOpen: () => "باز است",
            doorsClosed: "بسته اند", // all
            motion: () => "سنسور حرکت",
            motions: "سنسورهای حرکت",
            motionDetecting: c => (c > 1) ? "حرکت تشخیص می‌دهند" : "حرکت تشخیص می‌دهد",
            motionsIdle: "در حالت سکون اند", // all
            light: () => "چراغ",
            lights: "چراغ‌ها",
            lightOn: () => "روشن است",
            lightOff: "خاموش اند", // all
            automation: () => "اگر-آنگاه",
            automationTriggered: days => `در ${days} روز گذشته اجرا شده است`,
            scene: () => "سناریو",
            sceneRan: days => `در ${days} روز گذشته اجرا شده است`,
            user: () => "کاربر",
            usersHaveAccess: c => (c > 1) ? "به خانه دسترسی دارند" : "به خانه دسترسی دارد",
            connectedDevice: () => "دستگاه متصل است",
            disconnectedDevice: () => "دستگاه قطع است",
            totalDevice: () => "دستگاه\nدر مجموع",
        },
        appReports: {
            title: "گزارش‌های نرم‌افزار",
            sourceOfChanges: days => `علت‌هایی که در ${days} روز گذشته، دستگاه‌ها تغییر کرده اند`,
            percent: "٪",
            automations: " اگر-آنگاه",
            scenes: " سناریو",
            manual: " تغییر دستی",
            application: " با نرم‌افزار",
            mostActiveUsers: (countOfUsers, days) => `فعال‌ترین ${countOfUsers > 1 ? "کاربران" : "کاربر"} خانه در ${days} روز گذشته`,
            visit: () => "ورود به نرم‌افزار",
            command: () => "فرمان",
            comma: "،",
        },
        deviceReport: {
            title: "گزارش‌های دستگاه‌ها",
            now: "اکنون",
            time: () => " بار ",
            minute: () => "دقیقه",
            hour: () => "ساعت",
            opened: "باز شده است",
            motionDetected: "حرکت تشخیص داده است",
            soundDetected: "صدا تشخیص داده است",
            setPoint: "دمای هدف",
            envTemperature: "دمای محیط",
            envHumidity: "رطوبت محیط",
            envLight: "نور محیط",
            allLamps: "همه چراغ‌ها",
            thisWeek: "این هفته",
            lastWeek: "هفته پیش",
            twoWeeksAgo: "دو هفته پیش",
            allLampsInfoPrefix: () => `چراغ‌های خانه شما در این هفته به مدت `,
            allLampsInfoPostfix: () => ` ساعت روشن بوده اند.`
        },

        // rooms
        myHome: "کل خانه",
        rooms: {
            roomManagement: "مدیریت اتاق‌ها",
            rearrange: "تغییر ترتیب",
            rearrangeSave: "ذخیره‌ی ترتیب",
            add: "اضافه کردن اتاق",
            save: "ذخیره",
            next: "بعدی",
            mustEnterAName: "باید برای اتاق یک نام وارد کنید",
            notAny: "شما هیچ اتاقی ندارید",
            settings: "تنظیمات",
            chooseNameAndIcon: "انتخاب نام و شکل",
            name: "نام",
            namePlaceholder: "نام اتاق",
            icon: "شکل",
            color: "رنگ",
            removeAreYouSure: "آیا از حذف اتاق مطمئن هستید؟",
            removeConfirmOK: "حذف کن",
            removeConfirmNO: "نه، نگه‌ش دار",
            selectDevices: "انتخاب دستگاه‌ها",
            selectDevicesInfo: "برای ساخت اتاق جدید، دستگاه‌های آن را انتخاب کنید",
            editDevices: "ویرایش دستگاه‌ها",
            editDevicesInfo: "دستگاه‌های مربوط به این اتاق را انتخاب کنید",
            selectedDevices: "دستگاه‌های انتخاب شده",
        },

        // setting
        settings: "تنظیمات",
        profile: "پروفایل",
        language: "زبان",
        change: "تغییر",
        advancedOptions: "گزینه‌های پیشرفته",
        generalOptions: "گزینه‌های عمومی",
        about: "درباره",
        appSettings: "تنظیمات برنامه",
        homeManagement: "لیست خانه‌ها",
        noHomeInList: "شما هنوز در خانه‌ای عضو نیستید",
        homeProfile: "پروفایل خانه",
        clearData: "خروج و پاک کردن داده‌ها",
        clearDataConfirmOK: "همه را پاک کن",
        clearDataConfirmNO: "نه، چه کاریه!",
        clearDataConfirmAreYouSure: "آیا مطمئن هستید؟",
        removeAllDevicesConfirmOK: "همه را حذف کن",
        removeAllDevicesConfirmNO: "نه، نگه‌شون دار",
        removeAllDevicesConfirmAreYouSure: "آیا مطمئن هستید؟",
        reload: "تازه‌سازی مجدد",
        getPushPermission: "درخواست دسترسی ارسال اعلان",
        showSecondsInLog: "نمایش ثانیه در گزارش‌ها",
        showDeleteAllDevicesButton: "نمایش دکمه‌ی «حذف همه دستگاه‌ها»",
        enableDevTools: "فعال‌سازی ابزارهای توسعه‌دهنده",
        version: "نسخه‌ی",
        staging: "برای کابران اولیه",
        name: "نام",
        edit: "ویرایش",
        save: "ذخیره",
        changeAvatar: "تغییر آواتار",
        selectAvatar: "انتخاب آواتار",
        exitHome: "خروج",
        exitHomePopup: {
            header: "آیا می‌خواهید از «{0}» خارج شوید؟",
            onlyAdminInfo: "شما تنها ادمین این خانه هستید و با خروج شما، کل خانه و دستگاه‌ها از دسترس دیگر کاربران نیز حذف می‌شود.",
            nonAdminInfo: "با خروج شما، این خانه برای کاربران دیگر در دسترس باقی می‌ماند.",
            adminInfo: "شما ادمین این خانه هستید. اگر گزینه‌ی «خروج و حذف» را انتخاب کنید، کل خانه و دستگاه‌ها از دسترس دیگر کاربران نیز حذف می‌شود.",
            leave: "خروج", //  کاربر عادی + کاربر ادمین وقتی ادمین دیگه‌ای هم هست
            leaveAndDelete: "خروج و حذف", // تنها کاربر ادمین یا کاربر ادمین عادی
            no: "نه، نگه‌ش دار",
        },
        logoutSoloConfirmPopup: {
            header: "آیا مطمئناً می‌خواهید از سولو خارج شوید؟",
            info: "شما با ورود مجدد می‌توانید به خانه‌های سولو دسترسی داشته باشید.",
            ok: "خروج از سولو",
            no: "نه، نگهشان دار",
        },
        support: "پشتیبانی",
        opensourceLicenses: "مجوزهای متن‌باز",
        clientVersion: "نسخه‌ی نرم‌افزار کلاینت",
        clientVersionUpToDateInSetting: "نرم‌افزار کلاینت شما به آخرین نسخه بروزرسانی شده است.",
        hubVersion: "نسخه‌ی نرم‌افزار هاب",
        hubVersionUpToDateInSetting: "نرم‌افزار هاب شما به آخرین نسخه بروزرسانی شده است.",
        newVersionInfo: "نسخه‌ی جدید موجود و آماده‌ی نصب است.",
        newVersionTapToUpdate: "برای بروزرسانی کلیک کنید",
        userManagement: {
            addUser: "اضافه کردن کاربر",
            addUserInfo: "برای اشتراک این خانه با کاربر جدید، شماره تلفن کاربر را وارد کنید",
            noName: "هنوز انتخاب نشده است",
            title: "مدیریت کاربران",
            homeUsers: "کاربران خانه",
            pendingUsers: "درخواست‌ها",
            pendingUsersInfo: "کاربران زیر درخواست داده اند تا به خانه اضافه شوند؛ با این حال هنوز هیچ دسترسی‌ای ندارند.",
            detailTitleFormat: "پروفایل {0}",
            remove: "حذف",
            removeAreYouSure: "آیا مطمئن هستید؟",
            removeConfirmOK: "حذف کن",
            removeConfirmNO: "نه، نگه‌ش دار",
            noUser: "با استفاده از هاب، کاربر جدید اضافه کنید",
            notif: {
                title: "اعلان‌ها",
                automations: "اعلانِ اگر-آنگاه‌ها",
            },
            permissions: {
                title: "دسترسی‌ها",
                admin: "ادمین",
                deviceChangeState: "تغییر حالت دستگاه",
                automationSettings: "حذف و اضافه کردن اگر-آنگاه",
                automationEnable: "فعال و غیر فعال کردن اگر-آنگاه",
                sceneSettings: "حذف و اضافه کردن سناریو",
                sceneRun: "اجرای سناریو",
            },
            adminAreYouSure: "با این کار دسترسی ادمین از شما گرفته می‌شود، آیا مطمئن هستید؟",
            adminConfirmRemove: "حذف دسترسی",
            adminConfirmKeep: "نه، نگه‌ش دار",
            adminCantRemoveAccessFromYourselfPopup: {
                header: "شما تنها ادمین خانه هستید",
                body: "برای این کار باید دسترسی ادمین از شما گرفته شود ولی چون شما تنها ادمین این خانه هستید، این عملیات ممکن نیست.",
                ok: "باشه",
            },
        },
        multiOTA: {
            title: "بروزرسانی نسخه‌ی دستگاه‌ها",
            info: "نسخه‌ی جدیدی برای دستگاه‌های زیر موجود است",
            nonAdminInfo: "نسخه‌ی جدیدی برای دستگاه‌های زیر موجود است، از یک کاربر ادمین بخواهید که دستگاه‌ها را بروزرسانی کند",
            updateAll: "بروزرسانی همه",
            update: "بروزرسانی",
            nothingToOTA: "تمام دستگاه‌های آنلاین، بروز هستند",
        },

        // binds
        binds: "اگر-آنگاه‌ها",
        noBind: "اگر-آنگاهی وجود ندارد",
        updateHubToUseBind: "برای استفاده از اگر-آنگاه، نسخه‌ی نرم‌افزار هاب مرکزی را برورزسانی کنید",
        createBinds: "اگر-آنگاه جدید",
        bindText: {
            door: "در",
            opened: "باز شد",
            closed: "بسته شد",
            changed: "تغییر کرد",
            motion: "حرکت",
            motionDetected: "تشخیص حرکت",
            motionStopped: "توقف حرکت",
            temperature: "دما",
            humidity: "رطوبت",
            lightLevel: "سطح روشنایی",
            sound: "صدا",
            soundDetected: "تشخیص صدا",
            soundSilenced: "قطع شدن صدا",
            alarmSection: "آژیر",
            alarming: "آژیر زد",
            silenced: "آژیر قطع شد",
            batteryLevel: "سطح باتری",
            batteryLevelBecameCritical: "بحرانی شد",
            powerPluged: "برق وصل شد",
            powerUnpluged: "برق قطع شد",
            alarm: "آژیر بزند",
            silence: "آژیر قطع شود",
            power: "اتصال برق",
            turnedOn: "روشن شد",
            turnOn: "روشن شود",
            turnedOff: "خاموش شد",
            turnOff: "خاموش شود",
            change: "تغییر کند",
            open: "باز شود",
            close: "بسته شود",
            wcScenario: "تازه‌سازی",
            lamp: "چراغ",
            fan: "فن",
            spray: "اسپری",
            music: "موزیک",
            inUse: "در حال استفاده",
            refresh: "تازه‌سازی شود",
            refreshed: "تازه‌سازی شد",
            cancelRefresh: "تازه‌سازی متوقف شود",
            canceledRefresh: "تازه‌سازی متوقف شد",
            ring: "زنگ بزند",
            callElevator: "فراخوانی شود",
            cancel: "لغو شود",
            rang: "زنگ زد",
            calledElevator: "فراخوانی شد",
            canceled: "لغو شد",
            doSpray: "اسپری شود",
            didSpray: "اسپری شد",
            elevator: "آسانسور",
            doorbell: "زنگ در",
            switch: "کلید",
            switch1: "پل اول",
            switch2: "پل دوم",
            switch3: "پل سوم",
            switch4: "پل چهارم",
            channel1: "کانال اول",
            channel2: "کانال دوم",
            channel3: "کانال سوم",
            channel4: "کانال چهارم",
            curtain: "پرده",
            curtain1: "پرده‌ی اول",
            curtain2: "پرده‌ی دوم",
            alarmF: "ساعت {0} شد",
            emailF: "ارسال ایمیل به {0}",
            smsF: "ارسال پیامک به {0}",
            callF: "تماس با {0}",
            notif: "ارسال اعلان به کاربران انتخاب شده",
            tvPowerToggle: "روشن/خاموش شود",
            tvMuteToggle: "بی‌صدا/با صدا شود",
            tvSetChannelF: "به کانال {0} برود",
            splitStateF: "روشن | حالت: {0} | دما‌ی هدف: {1} | سرعت فن: {2}",
            splitState: {
                mode: {
                    heat: "گرمایش",
                    cool: "سرمایش",
                    dry: "کاهش رطوبت",
                    auto: "خودکار",
                    fanOnly: "فقط فن",
                },
                fan: {
                    auto: "خودکار",
                    x1: "کند",
                    x2: "متوسط",
                    x3: "تند",
                },
            },
            coolerStateF: "{0} | پمپ: {1} | فن: {2}",
            coolerStates: {
                on: "روشن",
                off: "خاموش",
                fast: "تند",
                slow: "کـنـد"
            },
            hinavaEcoThermostatStateF: "روشن | حالت: {0} | دما‌ی هدف: {1} | سرعت فن: {2}",
            hinavaEcoThermostatStateTurboF: "روشن | حالت: {0} | دما‌ی هدف: {1} | توربو",
            sednaStateF: "روشن | حالت: {0} | دما‌ی هدف: {1} | سرعت فن: {2} | حالت پیش‌فرض: {3}",
            temperatureConditionF: {
                0: "دمای محیط: کمتر از {0} درجه شد",
                1: "دمای محیط: برابر {0} درجه شد",
                2: "دمای محیط: بیشتر از {0} درجه شد",
            },
            humidityConditionF: {
                0: "رطوبت: کمتر از {0} درصد شد",
                1: "رطوبت: برابر {0} درصد شد",
                2: "رطوبت: بیشتر از {0} درصد شد",
            },
            brighnessConditionF: {
                0: "سطح روشنایی: کمتر از «{0}» شد",
                1: "سطح روشنایی: برابر «{0}» شد",
                2: "سطح روشنایی: بیشتر از «{0}» شد",
            },
            coolerPowerSection: "روشن/خاموش",
            coolerPumpSection: "پمپ",
            coolerFanSection: "سرعت",
            didSetToSlow: "کند شد",
            didSetToFast: "تند شد",
            willSetToSlow: "کند شود",
            willSetToFast: "تند شود",
            run: "اجرا شود",
            scenarioNameF: "سناریو {0}",
        },
        timezoneReset: "بازنشانی",
        timezoneStr: {
            "Asia/Tehran": "ایران",
            "Asia/Baghdad": "عراق"
        },
        createBindProcess: {
            // main
            editAutomation: "ویرایش اگر-آنگاه",
            createAutomation: "ساخت اگر-آنگاه",
            createAutomationInfo: "با استفاده از اگر-آنگاه می‌توانید برای کنترل دستگاه‌های هوشمند خود، دستورات شرطی تعریف کنید.",
            if: "اگر  ",
            then: "آنگاه  ",
            ifManyInfo: "(هر کدام از این اتفاقات افتاد)",
            thenManyInfo: "(تمام این کار‌ها انجام شود)",
            create: "بساز",
            delete: "پاک کردن",
            areYouSure: "آیا مطمئن هستید؟",
            deleteIt: "پاک کن",
            keepIt: "نه، نگه‌ش دار",
            addCondition: "اضافه کردن شرط",
            addAnotherCondition: "اضافه کردن شرط دیگر",
            noCondition: "اگر-آنگاه را ویرایش کرده و یک شرط اضافه کنید",
            addStatement: "اضافه کردن دستور",
            addAnotherStatement: "اضافه کردن دستور دیگر",
            noStatement: "اگر-آنگاه را ویرایش کرده و یک دستور اضافه کنید",
            participatesInCycle: "این اگر-آنگاه یک دور ایجاد کرده است.\nاگر-آنگاه‌های خود را ویرایش کرده و دور را حذف کنید.",
            setDelay: "تأخیر در اجرا",
            setDelayPageTitle: "تعیین تأخیر",
            setDelayButton: "ذخیره",
            setPeriod: "بازه‌ی زمانی",
            setPeriodPageTitle: "تعیین بازه‌ی زمانی",
            setPeriodButton: "ذخیره",
            advancedOptions: "گزینه‌های پیشرفته",
            delay: "تأخیر",
            period: "بازه‌ی زمانی",
            to: "تا",
            to_: "تا",
            clear: "پاک کردن",
            name: "نام",
            namePlaceHolder: "مثل «امنیت خانه» یا «درست کردن چای»",
            youMustEnterAName: "باید یک نام برای اگر-آنگاه وارد کنید",
            dayOfTheWeek: {
                title: "روز هفته",
                days: ["ش", "ی", "د", "س", "چ", "پ", "ج"],
                daysLong: ["شنبه", "یک‌شنبه", "دوشنبه", "سه‌شنبه", "چهار‌شنبه", "پنج‌شنبه", "جمعه"],
                allDays: "اگر-آنگاه می‌تواند در هر روزی اجرا شود.",
                selectiveDays: d => `اگر-آنگاه فقط می‌تواند در روزهای ${d} اجرا شود.`,
                comma: "، ",
                and2: " و ",
                andM: " و ",
                noday: "اگر-آنگاه در هیچ روزی از هفته نمی‌تواند اجرا شود.",
                nodayEdit: "اگر-آنگاه را ویرایش کرده و حداقل یک روز را انتخاب کنید.",
            },
            timezone: "منطقه زمانی",

            selectIfEventType: "نوع شرط را انتخاب کنید",
            device: "دستگاه",
            scenario: "سناریو",
            time: "زمان",

            selectStatementType: "نوع دستور را انتخاب کنید",
            call: "تماس",
            sms: "پیامک",
            notify: "اعلان",
            email: "ایمیل",

            selectDevice: "یک دستگاه را انتخاب کنید",
            selectScenario: "یک سناریو را انتخاب کنید",

            // chooseOneOfTheseStatements: "یک دستور را انتخاب کنید",

            whenTempIf: "اگر دما",
            chooseOneOfTheseConditions: "یکی از شرایط زیر را انتخاب کنید",
            whenConditionComparison: {
                lower: "کمتر شد از",
                equal: "برابر شد با",
                higher: "بیشتر شد از",
            },
            goToState: "به این حالت برود",

            whenTheClockShowsTheseNumbers: "زمان اجرا را تعیین کنید",
            chosseAddress: "آدرس ایمیل را وارد کنید",
            chosseNumber: "شماره‌ی تلفن را وارد کنید",
            youMustEnterAnAddress: "باید یک آدرس ایمیل وارد کنید",
            youMustEnterANumber: "باید یک شماره‌ی تلفن وارد کنید",
            phonenumber: "شماره‌ی تلفن ثابت یا همراه",
            next: "بعدی",

            // also used in scenario
            tvToggleOnOff: "دکمه‌ی خاموش/روشن",
            tvMute: "دکمه‌ی قطع صدا",
            tvChannelTitle: "رفتن به یک کانال",
            tvChannelLabel: "شماره‌ی کانال",
            tvYouMustEnterANumber: "باید شماره‌ی کانال را وارد کنید",
        },

        // messageCenter
        messageCenter: "پیام‌ها",
        messageCenterLoadingText: "درحال دریافت پیام‌ها",
        messageCenterCollapseText: "جزییات کمتر",
        messageCenterUncollapseText: "جزییات بیشتر",

        // update notification
        updateNotification: {
            hubTitle: "بروزرسانی نرم‌افزار هاب",
            clientTitle: "بروزرسانی نرم‌افزار کلاینت",
            changeHome: "انتخاب خانه‌ی دیگر", // -from_handshake-
            gotIt: "متوجه شدم",
            update: "بروزرسانی",
            later: "بعداً",
            criticalMessage: "اتصال به خانه به دلیل قدیمی‌شدن نسخه‌ی نرم‌افزار هاب ممکن نیست. لطفاً به هاب مراجعه کرده و آن را بروزرسانی کنید.",
            message: "نسخه‌ی نرم‌افزار هاب شما قدیمی شده است. می‌توانید از همین‌جا آن را بروزرسانی کنید.",
            clientMessage: "نسخه‌ی نرم‌افزار کلاینت شما قدیمی شده است. می‌توانید از همین‌جا آن را بروزرسانی کنید.",
            nonAdminMessage: "نسخه‌ی نرم‌افزار هاب شما قدیمی شده است. لطفاً آن را بروزرسانی کنید.",
            nonOTAMessage: "نسخه‌ی نرم‌افزار هاب شما قدیمی شده است. لطفاً به هاب مراجعه کرده و آن را بروزرسانی کنید.",
        },
        askPushPopup: {
            title: "دریافت اعلان",
            body: "با فعال کردن اعلان، از اتفاقاتی که در خانه‌تان رخ می‌دهد مطلع شوید.",
            allow: "تایید دریافت اعلان",
            later: "بعداً"
        },
        availabilityPopup: {
            removed: {
                title: "این خانه در دسترس نیست",
                body: "این خانه در دسترس نیست و امکان اتصال به آن وجود ندارد.",
            },
            offline: {
                title: "هاب مرکزی آفلاین است",
                body: "هاب مرکزی شما آفلاین است؛ لطفاً اینترنت هاب مرکزی را بررسی فرمایید. تلاش برای اتصال به هاب مرکزی در پس‌زمینه ادامه خواهد یافت.",
            },
            shouldlogin: {
                title: "مجددا به سولو وارد شوید",
                body: "نسشت شما منقضی شده است. لطفاً با استفاده از شماره‌تلفن خود، دوباره به سولو وارد شده و خانه‌ی مورد نظر را به لیست خود اضافه نمایید.",
            },
            changeHome: "انتخاب خانه‌ی دیگر",
            ok: "باشه",
        },

        otaReport: {
            title: {
                downloading: "در حال دانلود …", // + progress value
                installing: "در حال نصب …",  // + progress value
                done: "بروزرسانی پایان یافت",
                error: "خطایی رخ داد",
                formatTitleValue: (title, value) => `${title} %${value}`,
            },
            infoGeneral: "لطفاً صبور باشید و دستگاه را خاموش نکنید.\nشما می‌توانید این صفحه را ببندید یا این که به برنامه‌ی دیگری بروید، بروزرسانی در پس‌زمینه ادامه خواهد یافت.",
            infoError: "لطفاً دوباره تلاش کنید و اگر دوباره خطا رخ داد با پشتیبانی تماس بگیرید",
            infoDone: "بروزرسانی با موفقیت پایان یافت",
        },

        aiChat: {
            listening: "در حال گوش کردن",
            thinking: "در حال فکر کردن",
            clickToTalk: "برای صحبت کردن کلیک کنید",
            errorNotAllowed: "متاسفانه زبان فارسی در دستگاه شما پشتیبانی نمی‌شود",
        },
    },
    ar: {
        yourProfileInThisHome: {
            header: "ملفك الشخصي في هذا المنزل",
            info: "يمكنك استخدام ملفات تعريف مختلفة عبر منازل مختلفة",
            popupInfo: "يجب عليك إنشاء ملف تعريف لاستخدام هذا المنزل.",
            popupButton: "متابعة إنشاء ملفك الشخصي"
        },
        homeProfilePage: {
            createHeader: "منزل منفرد جديد",
            profleHeader: "ملف تعريف المنزل",
            info: "أنشئ منزلاً منفرداً جديداً لإدارة أجهزتك المنفردة",
            changeAvatar: "تغيير صورة المنزل",
            homeNamePlaceholder: "اسم منزلك",
            create: "إنشاء"
        }, welcome: "مرحباً بك في هينافا",
        addToHomeScreen: {
            header: "أضف تطبيق Hinava إلى شاشتك الرئيسية",
            snooze: "فهمت ذلك",
            messages: [
                <div className="text">1 - اضغط على زر <div className="share">مشاركة</div> من شريط الأدوات.</div>,
                <div className="text">2 - من القائمة المفتوحة اختر <div className="add-text">إضافة إلى الشاشة الرئيسية</div>.</div>,
                <div className="text">3 - اضغط على زر <div className="add-button">إضافة</div>.</div>
            ]
        }, changeLanguage: "تغيير اللغة",
        selectHomeTypeInfoPlease: "يرجى اختيار نوع منزلك",
        selectHomeTypeInfo: "اختر نوع منزلك",
        homeType: {
            hub: "الموزع (Hub)",
            hubInfo: "اختر للاتصال بالموزع الخاص بك",
            solo: "سحابة سولو (Solo Cloud)",
            soloInfo: "للأجهزة التي لا تملك موزعاً"
        }, namePlaceHolder: "اسمك",
        next: "التالي",
        youMustEnterAName: "يجب عليك إدخال اسم",
        logoutSolo: "تسجيل الخروج من سولو",
        connectToHub: "الاتصال بموزع هينافا المركزي",
        connectToHubInfo: "يرجى إدخال رقم الهاتف الذي استخدمته لتسجيل الموزع المركزي",
        gatewayNumber: "رقم الموزع",
        connectToSolo: "أدخل رقم الهاتف",
        connectToSoloInfo: "يرجى إدخال رقم هاتفك لتسجيل الدخول إلى Solo Cloud",
        phoneNumber: "رقم الهاتف",
        verificationCode: "رمز التحقق",
        verificationCodeInfoF: "يرجى إدخال رمز التحقق الذي تم إرساله لـ {0}",
        sendingVerificationCode: "جارٍ إرسال رمز التحقق",
        verifyingTheCode: "جارٍ تسجيل الدخول",
        useSimulatedGateway: "استخدم الموزع المحاكي!",
        connectToGateway: "جارٍ الاتصال بالموزع المركزي",
        tryAnotherHub: "جرب موزعاً آخر",
        tryAnotherPhoneNumber: "تغيير رقم الهاتف",
        waitingForAccept: "بانتظار القبول",
        waitingForAcceptInfo: "تم إرسال طلبك. يرجى قبول الطلب من خلال الموزع.",
        youMustEnterAPN: "يجب عليك إدخال رقم هاتف",
        youMustEnterTheCode: "يجب عليك إدخال رمز التحقق",
        loadingSoloHomes: "جارٍ تحميل المنازل المنفردة",
        creatingSoloHome: "إنشاء منزل منفرد",
        switchingSoloHome: "الانتقال إلى المنزل المنفرد الجديد",
        resendCodeLimit: "تم تجاوز حد إعادة الإرسال",
        resendCode: "إعادة إرسال الرمز",
        resendCodeInfoF: "يمكنك إرسال الرمز مرة أخرى بعد {0} ثانية",
        codeWasWrong: "الرمز الذي تم إدخاله خاطئ",
        home: "منزل",
        defaultHomeName: "منزلك",
        addHome: "إضافة منزل",
        statusConnecting: "جارٍ الاتصال",
        statusUpdating: "جارٍ التحديث",
        dataIsLoading: "جارٍ تحميل البيانات",
        statusStable: "مستقر",
        devices: "الأجهزة",
        addDevice: "إضافة جهاز",
        deleteAllDevices: "حذف جميع الأجهزة",
        noDevice: "ليس لديك أي جهاز بعد",
        off: "إيقاف",
        doorbell: {
            ringing: "رنين",
            tapToStop: "اضغط للتوقف"
        }, elevator: {
            calling: "جارٍ الاتصال",
            tapToStop: "اضغط للتوقف"
        }, pumpOff: "مضخة",
        slowOff: "بطيء",
        fastOff: "سريع",
        closed: "مغلق",
        open: "فتح",
        motionDetected: "تم اكتشاف حركة",
        motionNotDetected: "لا توجد حركة",
        soundDetected: "تم اكتشاف صوت",
        soundNotDetected: "لا يوجد صوت",
        percentFunc: (v) => v + " في المئة",
        cDegreeFunc: (v) => v + " درجة",
        noBatteryDetected: "لم يتم اكتشاف بطارية",
        deviceConnected: "متصل",
        deviceDC: "مفصول",
        deviceDisonnected: "غير متصل",
        reportsOfThisDevice: {
            label: "مخطط حالة الجهاز",
            smallerLabel: "لآخر 24 ساعة"
        }, bindsOfThisDevice: "الأتمتة المرتبطة بهذا الجهاز",
        noBindForThisDevice: "لا توجد أتمتة",
        noVirtualDeviceInRemote: "لم يتم إضافة جهاز تحكم عن بعد لهذا الجهاز بعد",
        lightLevels: [
            "شديد السواد",
            "مظلم جداً",
            "مظلم",
            "إضاءة طبيعية",
            "سطوع مريح",
            "ساطع بوضوح",
            "سطوع مبهر"
        ], curtain: {
            open: "فتح",
            opening: "جارٍ الفتح",
            close: "إغلاق",
            closing: "جارٍ الإغلاق",
            tapToStop: "اضغط للتوقف"
        }, scenarioSwitchSectionTitle: {
            o: "مفتاح الدائرة",
            x: "مفتاح الإشارة (Cross)",
            t: "مفتاح المثلث",
            r: "مفتاح المربع"
        }, scenarioSwitchSectionNotSpecified: "لا يوجد مشهد مرتبط بهذا المفتاح",
        scenarioSwitchAssociatedScenario: "اختر المشهد",
        deviceSettings: {
            button: "الإعدادات",
            name: "الاسم",
            edit: "تعديل",
            save: "حفظ",
            color: "اللون",
            useRoomColor: "استخدام لون الغرفة",
            colors: {
                0: "فيروزي",
                1: "غابة",
                2: "سماء",
                3: "محيط",
                4: "أرجواني ملكي",
                5: "ماجنتا",
                6: "فلامنجو",
                7: "أحمر ناري",
                8: "نمر",
                9: "كناري",
                10: "ثلج",
                11: "بدون لون"
            },
            syncSettings: {
                header: "الأجهزة المتزامنة",
                info: {
                    none: "غير متزامن مع أي جهاز",
                    main: "متزامن كجهاز رئيسي",
                    follower: "متزامن كجهاز تابع"
                },
                hint: "ستكون لجميع الأجهزة الرئيسية والتابعة حالة متزامنة، ويمكن عرضها أو تغييرها.",
                main: "الجهاز الرئيسي",
                follower: "الأجهزة التابعة",
                edit1: "تعديل الجهاز الرئيسي",
                edit: "تعديل الأجهزة",
                editButtonExplaned: "اختر الأجهزة التابعة",
                editInfo: "اختر جميع الأجهزة التابعة",
                removeSettings: "حذف هذه الإعدادات",
                areYouSure: "هل أنت متأكد؟ سيتم حذف إعدادات المزامنة وستعمل الأجهزة بشكل مستقل.",
                deleteIt: "احذفه",
                keepIt: "لا، احتفظ به"
            },
            sound: "الصوت",
            soundInfo: "تشغيل صوت نتيجة تفعيل المشهد",
            motionSensorSensitivity: "حساسية الحساس",
            motionSensorSensitivityInfo: "حساسية عالية (لأتمتة الإضاءة)",
            firmwareVersion: "إصدار البرنامج الثابت (Firmware)",
            firmwareIsLatest: "لديك أحدث إصدار",
            firmwareNewVersion: "يتوفر إصدار جديد للتثبيت",
            firmwareTapToUpdate: "اضغط لتثبيت التحديث الجديد",
            switchNames: "أسماء المفاتيح",
            switchNamesInfo: "تحديد أسماء المفاتيح",
            channelNames: "أسماء القنوات",
            channelNamesInfo: "تحديد أسماء القنوات",
            refreshDuration: "مدة التحديث",
            periodicRefresh: "تحديث دوري",
            periodicRefreshInfo: "تهوية الهواء بشكل دوري",
            durationBetweenRefreshes: "المدة بين التحديثات",
            musicInScenario: "الموسيقى في السيناريو",
            musicInScenarioInfo: "استخدام الموسيقى في السيناريو",
            scenarioKey: "مفتاح السيناريو",
            scenarioKeyInfo: "تفعيل السيناريو عن طريق لمس مفتاح المصباح",
            startingProcess: "جارٍ بدء العملية",
            pumpDuration: "مدة عمل المضخة",
            startWithFastMode: "البدء بالوضع السريع",
            startFastAfterPump: "البدء بالسريع بعد المضخة",
            keepFastMode: "الاحتفاظ بالوضع السريع",
            fastModeAsFinalState: "الوضع السريع كحالة نهائية",
            ringDuration: "مدة الرنين",
            elevatorLEDDuration: "مدة وصول المصعد التقريبية",
            curtainTime: "مدة الفتح/الإغلاق",
            curtainTime1: "مدة فتح/إغلاق الستارة الأولى",
            curtainTime2: "مدة فتح/إغلاق الستارة الثانية",
            degree: "درجة",
            degrees: "درجات",
            millisecond: "مللي ثانية",
            milliseconds: "مللي ثانية",
            second: "ثانية",
            seconds: "ثوانٍ",
            minute: "دقيقة",
            minutes: "دقائق",
            percent: "بالمئة",
            criticalBatteryLevel: "مستوى بطارية حرج",
            envTemperatureCalibrationOffset: "معايرة درجة حرارة البيئة",
            setpointHysteresis: "فرق الهسترة عن درجة الضبط",
            turboSetPointOffset: "إزاحة نقطة ضبط التربو",
            turboTimer: "مدة التربو",
            keepOnAfterRebootH: "انقطاع الطاقة",
            keepOnAfterReboot: "الاحتفاظ بالحالة بعد انقطاع الطاقة",
            showTemperatureWhenIsOffH: "وضع الإيقاف",
            showTemperatureWhenIsOff: "إظهار درجة الحرارة عندما يكون الجهاز مطفأً",
            switchName1: "اسم المفتاح الأول",
            switchName2: "اسم المفتاح الثاني",
            switchName3: "اسم المفتاح الثالث",
            switchName4: "اسم المفتاح الرابع",
            switchName1Default: "المفتاح الأول",
            switchName2Default: "المفتاح الثاني",
            switchName3Default: "المفتاح الثالث",
            switchName4Default: "المفتاح الرابع",
            channelName1: "اسم القناة الأولى",
            channelName2: "اسم القناة الثانية",
            channelName3: "اسم القناة الثالثة",
            channelName4: "اسم القناة الرابعة",
            channelName1Default: "القناة الأولى",
            channelName2Default: "القناة الثانية",
            channelName3Default: "القناة الثالثة",
            channelName4Default: "القناة الرابعة"
        },
        power: {
            stat: "إحصائيات الطاقة",
            showReport: "عرض التقارير",
            current: "الطاقة الحالية",
            statistics: "الإحصائيات",
            last1: "آخر 24 ساعة",
            last7: "آخر 7 أيام",
            last30: "الشهر الماضي",
            loading: "جارٍ جلب البيانات"
        },
        sirenState: {
            alarming: "في حالة إنذار",
            startAlarming: "جارٍ البدء",
            notAlarming: "جاهز"
        },
        thermostatOff: {
            title: "الجهاز متوقف عن التشغيل",
            button: "قم بتشغيل الجهاز"
        },
        sedna: {
            mode: "الوضع",
            heating: "تدفئة",
            cooling: "تبريد",
            fan: "مروحة",
            fanSpeed: "سرعة المروحة",
            fast: "سريع",
            medium: "متوسط",
            slow: "بطيء",
            auto: "تلقائي",
            scene: "الحالات المحددة مسبقاً",
            turbo: "تربو",
            leave: "مغادرة",
            manual: "يدوي",
            sleep: "نوم"
        },
        hinavaEcoThermostat: {
            mode: "الوضع",
            heating: "تدفئة",
            cooling: "تبريد",
            fan: "مروحة",
            fanSpeed: "سرعة المروحة",
            fast: "سريع",
            medium: "متوسط",
            slow: "بطيء",
            auto: "تلقائي",
            turboHeader: "حالة التربو",
            turbo: "تربو",
            manual: "يدوي"
        },
        marsus: {
            mode: {
                title: "الوضع",
                heat: "تدفئة",
                cool: "تبريد",
                auto: "تلقائي",
                manual: "يدوي",
                normal: "عادي",
                antiFreeze: "مانع التجمد",
                eco: "وضع التوفير"
            },
            fanSpeed: {
                title: "سرعة المروحة",
                fast: "سريع",
                medium: "متوسط",
                slow: "بطيء",
                auto: "تلقائي",
                off: "إيقاف"
            },
            pump: {
                title: "مضخة المياه",
                on: "تشغيل",
                off: "إيقاف التشغيل"
            }
        },
        addVirtualRemote: {
            button: "إضافة وحدة تحكم",
            subtypes: {
                tv: "تلفاز",
                split: "مكيف هواء"
            },
            selectSubType: "اختر نوع وحدة التحكم",
            selectBrand: "اختر العلامة التجارية",
            serachBrand: "ابحث عن العلامة التجارية",
            fetchingData: "جارٍ جلب البيانات",
            addingRemote: "جارٍ إضافة وحدة التحكم",
            noRemoteSupported: "هذا الجهاز لا يدعم أي من وحدات التحكم المتاحة",
            noBrandFound: "لم يتم العثور على علامة تجارية",
            noIndexFound: "لم يتم العثور على وحدة تحكم، يرجى اختيار علامة تجارية أخرى",
            retry: "إعادة المحاولة",
            errors: {
                1: "الجهاز غير متصل",
                2: "العملية غير مسموح بها",
                3: "البوابة (Gateway) غير متصلة بالخادم",
                4: "خطأ من خادم تويا"
            },
            indexHint: "يرجى التأكد من أن أكثر من 3 أزرار تعمل بشكل صحيح",
            selectIndex: "اختر هذا",
            nextIndex: "جرب التالي",
            enterName: "أدخل اسماً",
            deviceAddedInfo: "تمت إضافة وحدة التحكم إلى منزلك بنجاح",
            name: "الاسم",
            youMustEnterAName: "يجب إدخال اسم لوحدة التحكم",
            setName: "تم"
        },
        addDeviceProcess: {
            selectCategory: "اختر فئة الجهاز",
            categories: {
                touchSwitches: "مفاتيح باللمس",
                securityDevices: "أجهزة الأمان",
                temperatureControlDevices: "أجهزة التحكم بالحرارة",
                electricityControlDevices: "أجهزة التحكم بالكهرباء",
                convenienceDevices: "أجهزة الرفاهية"
            },
            selectType: "اختر نوع الجهاز",
            types: {
                evaporativeCooler: "مبرد صحراوي",
                plug: "مقبس ذكي",
                door: "حساس الباب",
                motion: "حساس الحركة",
                thermostat: "ثرموستات",
                hinavaEcoThermostat: "ثرموستات تايتان",
                sednaThermostat: "ثرموستات سيدنا (Sedna)",
                siren: "صافرة الإنذار",
                remote: "وحدة التحكم عن بعد",
                tuyaPhysicalRemote: "وحدة تحكم تويا (Tuya)",
                curtain: "ستارة",
                relay: "وحدة ترحيل (Relay)",
                scenarioSwitch: "مفتاح السيناريو",
                wc: "مفتاح دورة المياه",
                audioController: "وحدة التحكم بالصوت",
                multipurposeSensor: "حساس متعدد الأغراض",
                doorbell: "جرس الباب",
                elevator: "مفتاح المصعد"
            },
            selectSwitch: {
                categoryName: "مفتاح إضاءة",
                selectPageTitle: "اختر نوع المفتاح",
                classicName: "مفتاح كلاسيك",
                titanName: "مفتاح تايتان",
                liteName: "مفتاح لايت"
            },
            selectDoor: {
                categoryName: "حساس الباب",
                selectPageTitle: "اختر نوع الحساس",
                bleName: "حساس BLE كلاسيك",
                wifiName: "حساس Titan Wifi"
            },
            selectMotion: {
                categoryName: "حساس الحركة",
                selectPageTitle: "اختر نوع الحساس",
                bleName: "حساس BLE كلاسيك",
                wifiName: "حساس الواي فاي"
            },
            status: {
                pairing: "جارٍ الاقتران",
                joined: "تمت الإضافة بنجاح",
                connectionError: "لا يمكن الاتصال بالجهاز",
                unknownError: "خطأ في إضافة الجهاز"
            },
            selectAll: "إضافة كل الأجهزة",
            pairingStatus: "حالة الاقتران",
            curtainSelectNumChannelsPageTitle: "اختر عدد القنوات",
            curtainOneChannel: "التحكم في ستارة واحدة (قناة واحدة)",
            curtainTwoChannels: "التحكم في ستارتين (قناتين)",
            resetDevicePageTitle: "إعادة ضبط جهازك",
            connectNetwork: "الاتصال بشبكة WiFi",
            wifiGHz: "تأكد من ضبط شبكتك على تردد 2.4 جيجاهرتز",
            change: "تغيير",
            ssid: "اسم الشبكة (SSID)",
            ssidError: "يرجى إدخال اسم الشبكة الخاصة بك",
            password: "كلمة المرور",
            passwordError: "يرجى إدخال كلمة مرور الواي فاي الخاصة بك",
            next: "التالي",
            setName: "تم",
            finish: "تم",
            searchingDevice: "جارٍ البحث ...",
            searchBarText: "ثوانٍ لإنهاء البحث",
            searchBarText1: "ثانية لإنهاء البحث",
            searchTipsHeader: "تأكد من أن ",
            searchTips: [
                {
                    selector: {
                        wifi: [true, false],
                        pluggable: [true],
                    },
                    text: "الجهاز موصل بالكهرباء"
                },
                {
                    selector: {
                        wifi: [true, false],
                        pluggable: [true, false],
                    },
                    text: "تم إعادة ضبط الجهاز"
                },
                {
                    selector: {
                        wifi: [true],
                        pluggable: [true, false],
                    },
                    text: "تم إدخال كلمة مرور الواي فاي بشكل صحيح"
                },
                {
                    selector: {
                        wifi: [true, false],
                        pluggable: [true, false],
                    },
                    text: "الإنترنت متصل"
                }
            ],
            selectDevice: "اختر الجهاز",
            connecting: "جارٍ الاتصال",
            enterName: "أدخل اسماً",
            deviceAddedInfo: "تم إضافة الجهاز إلى منزلك بنجاح",
            setScenarioSwitchConfigTitle: "تهيئة مفتاح المشهد",
            name: "الاسم",
            youMustEnterAName: "يجب عليك إدخال اسم للجهاز",
            retry: "إعادة المحاولة",
            errors: {
                0: "اسم الشبكة غير صالح",
                1: "لا يمكن الاتصال بالشبكة",
                2: "لا يمكن الاتصال بالجهاز",
                3: "العملية غير مسموح بها",
                4: "لم يتم منح إذن البلوتوث في الموزع (Hub)",
                5: "لم يتم منح إذن الموقع في الموزع (Hub)",
                6: "البلوتوث مغلق، يجب عليك تفعيله في الموزع (Hub)",
                7: "الموقع مغلق، يجب عليك تفعيله في الموزع (Hub)",
                8: "لم يتم إدخال كلمة مرور الواي فاي",
                9: "يحتاج برنامج الجهاز إلى تحديث. يرجى الذهاب إلى الموزع وتحديث الجهاز",
                10: "خطأ بالتعامل ويه الجهاز",
                "wifi_ssid_error_general": "خطأ في الحصول على معلومات شبكة الواي فاي المتصلة",
                "wifi_ssid_error_1": "لم يتم منح إذن الموقع في الموزع (Hub)",
                "wifi_not_connected": "الموزع غير متصل بشبكة الواي فاي",
                "not_found": "لم يتم العثور على أي جهاز من هذا النوع",
                "another_search_in_progress": "فيه بحث ثاني شغال. استنى ٩٠ ثانية وجرب مرة ثانية.",
            },
            espTouchInstruction1: `١- نزّل برنامج EspTouch.`,
            espTouchInstruction23: `٢- بهالبرنامج، اختار خيار EspTouch وادخل معلومات الواي فاي.\n٣- هسه لازم ضوء الجهاز يصير برتقالي.`,
            deviceLEDColorBecameOrange: "ضوء الجهاز صار برتقالي",
            locationWarning: "إذا كان الهَب مالتك متصل لاسلكياً (واي فاي)، فعّل إذن استخدام مستشعر الموقع على الهَب حتى تصير هالعملية تلقائية. استخدام تطبيق هيناوا للأندرويد مرة وحدة هم يخلي هالعملية تلقائية.",
            esptouchHintToUseAndroidClient: "استخدام عميل هينافا على أندرويد مرة وحدة رح يخلّي هالعملية تصير تلقائياً.",
            resetInstruction: {
                plug: "1- قم بتوصيل جهازك بالكهرباء. 2- المس مع الاستمرار الخط الأمامي لمدة 5 ثوانٍ كما ترى في الصورة. 3- يجب أن يومض مؤشر الجهاز باللون الأبيض لفترة وجيزة.",
                audioController: "1- قم بتوصيل جهازك بالكهرباء. 2- اضغط مع الاستمرار على زر \"ON/OFF\" لمدة 5 ثوانٍ. 3- يجب أن يبدأ مؤشر الحالة بالوميض باللون السماوي.",
                classicSwitch: "1- قم بتثبيت جهازك وتأكد من توصيله بالطاقة. 2- المس مع الاستمرار كلاً من المفتاحين بإصبعين لمدة 5 ثوانٍ. 3- يجب أن تومض مصابيح المفاتيح و \"Hinava\" باللون الأزرق لفترة وجيزة.",
                evaporativeCooler: "1- قم بتثبيت جهازك وتأكد من توصيله بالطاقة. 2- المس مع الاستمرار مفتاحي التشغيل والمضخة بإصبعين لمدة 5 ثوانٍ. 3- سيصدر الجهاز صوتاً لتأكيد إعادة الضبط وسيومض \"Hinava\" مرة واحدة. 4- بعد 5 إلى 10 ثوانٍ، يجب أن يبدأ مؤشر \"Hinava\" بالوميض بسرعة باللون السماوي.",
                titanSwitch: "1- قم بتثبيت جهازك وتأكد من توصيله بالطاقة. 2- المس مع الاستمرار أول مفتاحين بإصبعين لمدة 5 ثوانٍ (امسك المفتاح الأول في حالة المفتاح الفردي). 3- سيصدر الجهاز صوتاً لتأكيد إعادة الضبط وسيومض \"Hinava\" مرة واحدة. 4- بعد 5 إلى 10 ثوانٍ، يجب أن يبدأ مؤشر \"Hinava\" بالوميض بسرعة باللون السماوي.",
                liteSwitch: "1- قم بتثبيت جهازك وتأكد من توصيله بالطاقة. 2- المس مع الاستمرار أول مفتاحين بإصبعين لمدة 5 ثوانٍ (امسك المفتاح الأول في حالة المفتاح الفردي). 3- سيصدر الجهاز صوتاً لتأكيد إعادة الضبط وسيومض مؤشر الخط مرة واحدة. 4- بعد 5 إلى 10 ثوانٍ، يجب أن يبدأ مؤشر الخط بالوميض بسرعة باللون السماوي.",
                hinavaEcoThermostat: "1- قم بتثبيت جهازك وتأكد من توصيله بالطاقة. 2- المس مع الاستمرار زري الوضع والمروحة في وقت واحد بإصبعين لمدة 5 ثوانٍ. 4- بعد 5 إلى 10 ثوانٍ، يجب أن يبدأ مؤشر \"Hinava\" بالوميض بسرعة باللون السماوي.",
                scenarioSwitch: "1- قم بتثبيت جهازك وتأكد من توصيله بالطاقة. 2- المس مع الاستمرار أول مفتاحين بإصبعين لمدة 5 ثوانٍ. 3- سيصدر الجهاز صوتاً لتأكيد إعادة الضبط وسيومض \"Hinava\" مرة واحدة. 4- بعد 5 إلى 10 ثوانٍ، يجب أن يبدأ مؤشر \"Hinava\" بالوميض بسرعة باللون السماوي.",
                curtain: "1- قم بتثبيت جهازك وتأكد من توصيله بالطاقة. 2- المس مع الاستمرار أول مفتاحين بإصبعين لمدة 5 ثوانٍ. 3- سيصدر الجهاز صوتاً لتأكيد إعادة الضبط وسيومض \"Hinava\" مرة واحدة. 4- بعد 5 إلى 10 ثوانٍ، يجب أن يبدأ مؤشر \"Hinava\" بالوميض بسرعة باللون السماوي.",
                relay: "1- قم بتثبيت جهازك وتأكد من توصيله بالطاقة. 2- المس مع الاستمرار الزرين الأول والرابع بإصبعين لمدة 5 ثوانٍ. 3- بعد 5 إلى 10 ثوانٍ، يجب أن يبدأ مؤشر الجهاز بالوميض بسرعة باللون السماوي.",
                doorWifi: "1- حرك الجهاز للأعلى وافصله عن الجدار. 2- تأكد من توصيل الطاقة. 3- اضغط مع الاستمرار على الزر الأبيض الموجود فوق البطارية لمدة 5 ثوانٍ. 4- يجب أن يومض المؤشر الأمامي للجهاز باللون السماوي.",
                door: "1- ضع البطارية وتأكد من أنها ليست فارغة. 2- اضغط مع الاستمرار على الزر الأبيض القريب من البطارية لمدة 5 ثوانٍ. 3- يجب أن يومض مؤشر الجهاز باللون الأبيض لفترة وجيزة.",
                motion: "1- ضع البطارية وتأكد من أنها ليست فارغة. 2- اضغط مع الاستمرار على زر إعادة الضبط (الموجود بالقرب من البطارية وداخل الفتحة) باستخدام دبوس لمدة 5 ثوانٍ. 3- يجب أن يومض مؤشر الجهاز باللون الأبيض لفترة وجيزة.",
                motionWifi: "1- ضع البطارية وتأكد من أنها ليست فارغة. 2- اضغط مع الاستمرار على زر إعادة الضبط (الموجود بالقرب من البطارية وداخل الفتحة) باستخدام دبوس لمدة 5 ثوانٍ. 3- يجب أن يبدأ مؤشر الجهاز بالوميض بسرعة باللون السماوي.",
                remote: "1- قم بتوصيل جهازك بالكهرباء. 2- اضغط مع الاستمرار على زر إعادة الضبط (الموجود داخل الفتحة) باستخدام دبوس لمدة 5 ثوانٍ كما ترى في الصورة. 3- يجب أن يبدأ مؤشر الجهاز بالوميض باللون السماوي.",
                siren: "1- تأكد من أن بطارية الجهاز ليست فارغة. 2- افصل الجهاز إذا كان متصلاً. 3- اضغط مع الاستمرار على زر إعادة الضبط (الموجود داخل الفتحة) باستخدام دبوس لمدة 5 ثوانٍ كما ترى في الصورة. 4- يجب أن يبدأ مؤشر الجهاز بالوميض بسرعة باللون السماوي.",
                general: "1- قم بتثبيت الجهاز وتأكد من توصيله بالطاقة. 2- اتبع التعليمات الموجودة في دليل المستخدم لإعادة ضبط الجهاز."
            },
            resetInstructionConfirm: {
                blinkedLikeFigure: "ومض الجهاز كما في الصورة",
                blinkingLikeFigure: "الجهاز يومض كما في الشكل",
                fastBlinkingLikeFigure: "الجهاز يومض بسرعة",
                onReadyToSetupPhase: "الجهاز جاهز للإعداد الآن"
            }
        },
        removeDeviceConfirmAreYouSure: "هل أنت متأكد؟",
        removeDeviceConfirmOK: "احذفه",
        removeDeviceConfirmNO: "لا، احتفظ به",
        subRemotesOfThisRemote: "أجهزة التحكم عن بعد لهذا الجهاز",
        audioController: {
            currentPlaylist: "قائمة التشغيل الحالية",
            currentPlaylistEmpty: "قائمة التشغيل الحالية فارغة",
            currentPlaylistEdit: "اختر الموسيقى",
            modeIsNotHinava: "مدخل الجهاز ليس موزع هينافا",
            setHinavaMode: "استخدم موزع هينافا كمدخل",
            deviceIsOff: "وحدة التحكم بالصوت مطفأة",
            turnDeviceOn: "قم بتشغيل وحدة التحكم بالصوت",
            manage: "إدارة",
            mode: "المدخلات (Input)",
            modeHinava: "هينافا (بصري)",
            modeBluetooth: "بلوتوث",
            modeAUX: "AUX",
            modeHDMI: "HDMI",
            zones: "المناطق",
            zone1: "منطقة 1",
            zone2: "منطقة 2",
            zone3: "منطقة 3",
            zone4: "منطقة 4",
            zoneEditNames: "تعديل الأسماء",
            zoneSaveNames: "حفظ الأسماء",
            chooseMusicList: "اختر قائمة الموسيقى",
            folders: "المجلدات",
            albums: "الألبومات",
            track: "مقطع",
            tracks: "مقاطع",
            reload: "إعادة تحميل",
            chooseAndPlay: "اختر وشغل",
            loadingData: "جارٍ تحميل البيانات",
            noMusicFound: "لم يتم العثور على موسيقى",
            listDetailFunc: name => "أغاني " + name,
        },
        wc: {
            inUse: "قيد الاستخدام",
            refreshing: "جارٍ التحديث",
            refresh: "تحديث"
        },
        scenarios: "المشاهد",
        noScenario: "لا يوجد مشهد",
        createScenarios: "إنشاء مشهد",
        runScenario: {
            titleHead: "تشغيل '",
            titleTail: "سيناريو",
            gotIt: "فهمت"
        },
        siriScenario: {
            titleFunc: (name) => "اتصال سيناريو " + name + "\nللمساعد الصوتي سيري",
            section1Text: "نسخ مفتاح الوصول:",
            section1Button: "نسخ مفتاح الوصول",
            section2Text: "انقر على الزر أدناه لفتح تطبيق الاختصارات.\n ثم، في الصفحة التي تفتح، انقر على زر \"إعداد الاختصار\".\n بعد ذلك، ستفتح صفحة وسيُطلب منك لصق مفتاح الوصول هناك.",
            section2Button: "فتح الاختصارات",
            section3Text: "لاستخدام المساعد الرقمي Siri على الهاتف أو الساعة الذكية، بعد تفعيل Siri في إعدادات الهاتف، يمكنك تشغيل المساعد بقول \"Hey Siri\".\nثم بقول الأمر \"Run Hinava Scene\"، ستقوم Siri بتشغيل المشهد.\nيمكنك أيضاً تغيير اسم الأمر الصوتي عن طريق إعادة تسمية الاختصار.",
            copied: "تم النسخ"
        },
        createScenarioProcess: {
            selectDevices: "اختر الأجهزة",
            selectDevicesInfo: "اختر جميع الأجهزة التي تريد استخدامها في هذا المشهد",
            next: "التالي",
            selectBinds: "اختر الأتمتة",
            selectBindsInfo: "اختر جميع الأتمتة التي تريد استخدامها في هذا المشهد",
            setState: "ضبط الحالة",
            set: "ضبط",
            enable: "تفعيل",
            disable: "تعطيل",
            sirenAlarming: "في حالة إنذار",
            sirenNotAlarming: "ليس في حالة إنذار",
            powerOn: "تشغيل",
            powerOff: "إيقاف التشغيل",
            inUse: "قيد الاستخدام",
            refresh: "تحديث",
            setThisStateImmediately: "ضبط هذه الحالة فوراً",
            editScenario: "تعديل المشهد",
            overview: "نظرة عامة",
            backToOverview: "العودة إلى النظرة العامة",
            youMustSelectADOB: "يجب عليك اختيار جهاز أو أتمتة واحدة على الأقل",
            devices: "الأجهزة",
            noDevice: "لم يتم اختيار أي جهاز",
            binds: "الأتمتة",
            noBind: "لم يتم اختيار أي أتمتة",
            delete: "حذف",
            areYouSure: "هل أنت متأكد؟",
            deleteIt: "احذفه",
            keepIt: "لا، احتفظ به",
            giveNameAndIcon: "اختر الاسم والأيقونة",
            name: "الاسم",
            icon: "أيقونة",
            youMustEnterAName: "يجب عليك إدخال اسم",
            create: "إنشاء",
            edit: "تعديل",
            namePlaceHolders: {
                1: "عام",
                2: "سفر",
                3: "فيلم",
                4: "عيد ميلاد",
                5: "مغادرة المنزل",
                6: "دخول المنزل",
                7: "إطفاء الأنوار",
                8: "إضاءة الأنوار",
                9: "نوم"
            }
        },
        logs: "التقارير",
        noLogs: "لا توجد تقارير",
        logIsRedacted: "تتوفر المزيد من المعلومات للمستخدمين المسؤولين",
        logSubjectF: {
            hub: "بواسطة الموزع المركزي",
            general: "بواسطة {0}",
            bind: "بواسطة أتمتة {0}",
            scenario: "بواسطة مشهد {0}"
        },
        logRefresh: {
            button: "إعادة تحميل",
            instructionsPullToRefresh: "اسحب للأسفل للتحديث",
            instructionsReleaseToRefresh: "حرر للتحديث",
            instructionsRefreshing: "جارٍ التحديث"
        },
        logFilter: {
            button: "تصفية التقارير",
            filteredBy: "مصنف بواسطة",
            filters: "الفلاتر",
            filtersInfo: "من خلال اختيار الفلاتر، اجعل التقارير أكثر تحديداً.",
            clear: "مسح",
            selectAll: "اختيار الكل",
            saveAndApply: "حفظ وتطبيق",
            time: {
                itemTitle: "الوقت",
                pageTitle: "تصفية الوقت",
                pageInfo: "اختر إطاراً زمنياً",
                noSelection: "لم يتم اختيار إطار زمني",
                someSelection: count => count + " أيام مختارة",
                someSelectionSmall: count => count + " أيام",
                youMustEnterATimeFrame: "يجب عليك إدخال إطار زمني"
            },
            user: {
                itemTitle: "المستخدمون",
                pageTitle: "تصفية المستخدمين",
                pageInfo: "اختر المستخدمين الذين يهمونك لرؤية السجلات المتعلقة بهم",
                noSelection: "لم يتم اختيار أي مستخدمين",
                someSelection: count => count + " مستخدم مختار",
                someSelectionSmall: count => count + " مستخدم",
            },
            device: {
                itemTitle: "الأجهزة",
                pageTitle: "تصفية الأجهزة",
                pageInfo: "اختر الجهاز الذي يهمك لرؤية السجلات المتعلقة به",
                noSelection: "لم يتم اختيار أي جهاز",
                someSelection: count => count + " جهاز مختار",
                someSelectionSmall: count => count + " جهاز",
            },
            bind: {
                itemTitle: "الأتمتة",
                pageTitle: "تصفية الأتمتة",
                pageInfo: "اختر الأتمتة التي تهمك لرؤية السجلات المتعلقة بها",
                noSelection: "لم يتم اختيار أي أتمتة",
                someSelection: count => count + " الأتمتة مختار",
                someSelectionSmall: count => count + " الأتمتة",
            },
            scenario: {
                itemTitle: "المشاهد",
                pageTitle: "تصفية المشاهد",
                pageInfo: "اختر المشاهد التي تهمك لرؤية السجلات المتعلقة بها",
                noSelection: "لم يتم اختيار مشاهد",
                someSelection: count => count + " المشاهد مختار",
                someSelectionSmall: count => count + " المشاهد",
            },
            room: {
                itemTitle: "الغرف",
                pageTitle: "تصفية الغرف",
                pageInfo: "اختر الغرف التي تهمك لرؤية السجلات المتعلقة بها",
                noSelection: "لم يتم اختيار غرف",
                someSelection: count => count + " الغرف مختار",
                someSelectionSmall: count => count + " الغرف",
            }
        },
        insightsSummary: {
            title: "ملخص",
            detailedReports: "تقارير مفصلة",
            all: "الكل",
            door: () => "حساس الباب",
            doors: "حساسات الأبواب",
            doorOpen: () => "مفتوح",
            doorsClosed: "مغلقة",
            motion: () => "حساس الحركة",
            motions: "حساسات الحركة",
            motionDetecting: c => (c > 1) ? "تكتشف الحركة" : "تكتشف الحركة",
            motionsIdle: "في حالة سكون",
            light: () => "مصباح",
            lights: "الأنوار",
            lightOn: () => "مضيئة",
            lightOff: "مطفأة",
            automation: () => "شرط-نتيجة",
            automationTriggered: days => `تم تنفيذه في ${days} الأيام الماضية`,
            scene: () => "سيناريو",
            sceneRan: days => `تم تنفيذه في ${days} الأيام الماضية`,
            user: () => "مستخدم",
            usersHaveAccess: c => (c > 1) ? "لديهم وصول إلى المنزل" : "لديه وصول إلى المنزل",
            connectedDevice: () => "الجهاز متصل",
            disconnectedDevice: () => "الجهاز مفصول",
            totalDevice: () => "الجهاز\nمجموع"
        },
        appReports: {
            title: "تقارير التطبيق",
            sourceOfChanges: days => `الأسباب التي تغيرت فيها الأجهزة خلال ${days} يومًا الماضية`,
            percent: "%",
            automations: "الأتمتة",
            scenes: "المشاهد",
            manual: "يدوي",
            application: "التطبيق",
            mostActiveUsers: (countOfUsers, days) => `أكثر ${countOfUsers > 1 ? "المستخدمين" : "مستخدمًا"} نشاطًا في المنزل خلال ${days} يومًا الماضية`,
            visit: () => "الدخول إلى التطبيق",
            command: () => "أمر",
            comma: ","
        },
        deviceReport: {
            title: "تقارير الجهاز",
            now: "الآن",
            time: () => "مرات",
            minute: () => "دقيقة",
            hour: () => "ساعة",
            opened: "مفتوح",
            motionDetected: "تم اكتشاف حركة",
            soundDetected: "تم اكتشاف صوت",
            setPoint: "نقطة الضبط",
            envTemperature: "درجة حرارة البيئة",
            envHumidity: "رطوبة البيئة",
            envLight: "إضاءة البيئة",
            allLamps: "جميع المصابيح",
            thisWeek: "هذا الأسبوع",
            lastWeek: "الأسبوع الماضي",
            twoWeeksAgo: "قبل أسبوعين",
            allLampsInfoPrefix: () => `مصابيح المنزل الخاصة بك كانت مضاءة لمدة `,
            allLampsInfoPostfix: () => ` ساعة في هذا الأسبوع.`
        },
        myHome: "منزلي",
        rooms: {
            roomManagement: "إدارة الغرف",
            rearrange: "إعادة ترتيب",
            rearrangeSave: "حفظ الترتيب",
            add: "إضافة غرفة",
            save: "حفظ",
            next: "التالي",
            mustEnterAName: "يجب عليك إدخال اسم للغرفة",
            notAny: "ليس لديك أي غرفة",
            settings: "الإعدادات",
            chooseNameAndIcon: "اختر الاسم والأيقونة",
            name: "الاسم",
            namePlaceholder: "اسم الغرفة",
            icon: "أيقونة",
            color: "اللون",
            removeAreYouSure: "هل أنت متأكد؟",
            removeConfirmOK: "احذفه",
            removeConfirmNO: "لا، احتفظ به",
            selectDevices: "اختر الأجهزة",
            selectDevicesInfo: "اختر جميع الأجهزة التي تريد تعيينها للغرفة الجديدة",
            editDevices: "تعديل الأجهزة",
            editDevicesInfo: "اختر جميع الأجهزة التي تريد تعيينها لهذه الغرفة",
            selectedDevices: "الأجهزة المختارة"
        },
        settings: "الإعدادات",
        profile: "الملف الشخصي",
        language: "اللغة",
        change: "تغيير",
        advancedOptions: "خيارات متقدمة",
        generalOptions: "خيارات عامة",
        about: "حول",
        appSettings: "إعدادات التطبيق",
        homeManagement: "قائمة المنازل",
        noHomeInList: "لست عضواً في أي منزل بعد",
        homeProfile: "ملف تعريف المنزل",
        clearData: "تسجيل الخروج ومسح البيانات",
        clearDataConfirmOK: "مسح جميع البيانات",
        clearDataConfirmNO: "لا، لا تلمسها!",
        clearDataConfirmAreYouSure: "هل أنت متأكد؟",
        removeAllDevicesConfirmOK: "حذف جميع الأجهزة",
        removeAllDevicesConfirmNO: "لا، احتفظ بها",
        removeAllDevicesConfirmAreYouSure: "هل أنت متأكد؟",
        reload: "إعادة تحميل التطبيق",
        getPushPermission: "الحصول على إذن التنبيهات",
        showSecondsInLog: "إظهار الثواني في السجل",
        showDeleteAllDevicesButton: "إظهار زر \"حذف جميع الأجهزة\"",
        enableDevTools: "تفعيل أدوات المطور",
        version: "الإصدار",
        staging: "مرحلة الاختبار (Staging)",
        name: "الاسم",
        edit: "تعديل",
        save: "حفظ",
        changeAvatar: "تغيير الصورة الرمزية",
        selectAvatar: "اختر صورة رمزية",
        exitHome: "خروج",
        exitHomePopup: {
            header: "هل أنت متأكد أنك تريد مغادرة “{0}”؟",
            onlyAdminInfo: "أنت المسؤول الوحيد عن هذا المنزل وعند مغادرتك، سيتم أيضاً إزالة المنزل بالكامل والأجهزة للمستخدمين الآخرين.",
            nonAdminInfo: "عند مغادرتك، يظل هذا المنزل متاحاً للمستخدمين الآخرين.",
            adminInfo: "أنت مسؤول هذا المنزل. إذا اخترت خيار \"المغادرة والحذف\"، فسيتم أيضاً حذف المنزل والأجهزة بالكامل للمستخدمين الآخرين.",
            leave: "مغادرة",
            leaveAndDelete: "مغادرة وحذف",
            no: "لا، احتفظ به"
        },
        logoutSoloConfirmPopup: {
            header: "هل أنت متأكد أنك تريد تسجيل الخروج من سحابة سولو؟",
            info: "يمكنك الوصول إلى منازل سولو بعد تسجيل الدخول مرة أخرى.",
            ok: "تسجيل الخروج من سولو",
            no: "لا، احتفظ بها"
        },
        support: "الدعم",
        opensourceLicenses: "تراخيص المصادر المفتوحة",
        clientVersion: "إصدار برنامج العميل",
        clientVersionUpToDateInSetting: "برنامج العميل الخاص بك محدث.",
        hubVersion: "إصدار برنامج الموزع",
        hubVersionUpToDateInSetting: "برنامج الموزع الخاص بك محدث.",
        newVersionInfo: "يتوفر إصدار جديد للتثبيت.",
        newVersionTapToUpdate: "اضغط لتثبيت التحديث الجديد",
        userManagement: {
            addUser: "إضافة مستخدم",
            addUserInfo: "أدخل رقم هاتف المستخدم لمشاركة المنزل",
            noName: "غير محدد",
            title: "إدارة المستخدمين",
            homeUsers: "مستخدمو المنزل",
            pendingUsers: "مستخدمون في الانتظار",
            pendingUsersInfo: "طلب المستخدمون التاليون الانضمام إلى المنزل، على الرغم من أنهم لا يملكون أي صلاحية وصول حالياً.",
            detailTitleFormat: "ملف تعريف {0}",
            remove: "إزالة",
            removeAreYouSure: "هل أنت متأكد؟",
            removeConfirmOK: "إزالته",
            removeConfirmNO: "لا، احتفظ به",
            noUser: "استخدم الموزع لإضافة مستخدم جديد.",
            notif: {
                title: "التنبيه",
                automations: "تنبيه الأتمتة"
            },
            permissions: {
                title: "الصلاحيات",
                admin: "مسؤول",
                deviceChangeState: "تغيير حالة الجهاز",
                automationSettings: "إنشاء وإزالة الأتمتة",
                automationEnable: "تعطيل وتفعيل الأتمتة",
                sceneSettings: "إنشاء وإزالة المشهد",
                sceneRun: "تشغيل المشهد"
            },
            adminAreYouSure: "سيؤدي هذا إلى إزالة إذن \"المسؤول\" الخاص بك. هل أنت متأكد؟",
            adminConfirmRemove: "إزالته",
            adminConfirmKeep: "لا، احتفظ به",
            adminCantRemoveAccessFromYourselfPopup: {
                header: "أنت المسؤول الوحيد لهذا المنزل",
                body: "سيؤدي هذا إلى إزالة إذن \"المسؤول\" الخاص بك. ولكنك المسؤول الوحيد لهذا المنزل، لذا لا يمكننا القيام بهذه العملية.",
                ok: "موافق"
            }
        },
        multiOTA: {
            title: "تحديث البرنامج الثابت للجهاز",
            info: "هذه الأجهزة تتوفر لها إصدارات أحدث",
            nonAdminInfo: "هذه الأجهزة تتوفر لها إصدارات أحدث، اطلب من المسؤول تحديث الجهاز",
            updateAll: "تحديث الكل",
            update: "تحديث",
            nothingToOTA: "جميع الأجهزة المتصلة محدثة"
        },
        binds: "الأتمتة",
        noBind: "لا توجد أتمتة",
        updateHubToUseBind: "قم بتحديث تطبيق الموزع لاستخدام الأتمتة",
        createBinds: "إنشاء أتمتة",
        bindText: {
            door: "باب",
            opened: "مفتوح",
            closed: "مغلق",
            changed: "تم التغيير",
            motion: "حركة",
            motionDetected: "تم الكشف",
            motionStopped: "توقف",
            temperature: "درجة الحرارة",
            humidity: "الرطوبة",
            lightLevel: "مستوى الإضاءة",
            sound: "صوت",
            soundDetected: "تم الكشف",
            soundSilenced: "صامت",
            alarmSection: "إنذار",
            alarming: "إنذار جاري",
            silenced: "توقف الإنذار",
            batteryLevel: "مستوى البطارية",
            batteryLevelBecameCritical: "أصبح حرجاً",
            powerPluged: "تم توصيل الطاقة",
            powerUnpluged: "تم فصل الطاقة",
            alarm: "بدء الإنذار",
            silence: "إيقاف الإنذار",
            power: "طاقة",
            turnedOn: "تم التشغيل",
            turnOn: "تشغيل",
            turnedOff: "تم الإيقاف",
            turnOff: "إيقاف التشغيل",
            change: "تغيير",
            open: "فتح",
            close: "إغلاق",
            wcScenario: "تحديث",
            lamp: "مصباح",
            fan: "مروحة",
            spray: "رش",
            music: "موسيقى",
            inUse: "قيد الاستخدام",
            refresh: "تحديث",
            refreshed: "تم التحديث",
            cancelRefresh: "إيقاف التحديث",
            canceledRefresh: "توقف التحديث",
            ring: "رنين",
            callElevator: "اتصال",
            cancel: "إلغاء",
            rang: "رن",
            calledElevator: "تم الاتصال",
            canceled: "مُلغى",
            doSpray: "رش",
            didSpray: "تم الرش",
            elevator: "مصعد",
            doorbell: "جرس الباب",
            switch: "مفتاح",
            switch1: "المفتاح الأول",
            switch2: "المفتاح الثاني",
            switch3: "المفتاح الثالث",
            switch4: "المفتاح الرابع",
            channel1: "القناة الأولى",
            channel2: "القناة الثانية",
            channel3: "القناة الثالثة",
            channel4: "القناة الرابعة",
            curtain: "ستارة",
            curtain1: "الستارة الأولى",
            curtain2: "الستارة الثانية",
            alarmF: "الساعة تظهر {0}",
            emailF: "إرسال بريد إلكتروني إلى {0}",
            smsF: "نص {0}",
            callF: "اتصال بـ {0}",
            notif: "إرسال تنبيه للمستخدمين المختارين",
            tvPowerToggle: "تبديل التشغيل/الإيقاف",
            tvMuteToggle: "تبديل كتم الصوت",
            tvSetChannelF: "ضبط رقم القناة على {0}",
            splitStateF: "تشغيل | الوضع: {0} | درجة الحرارة: {1}°م | سرعة المروحة: {2}",
            splitState: {
                mode: {
                    heat: "تدفئة",
                    cool: "تبريد",
                    dry: "تجفيف",
                    auto: "تلقائي",
                    fanOnly: "مروحة فقط"
                },
                fan: {
                    auto: "تلقائي",
                    x1: "بطيء",
                    x2: "متوسط",
                    x3: "سريع"
                }
            },
            coolerStateF: "{0} | المضخة: {1} | المروحة: {2}",
            coolerStates: {
                on: "تشغيل",
                off: "إيقاف التشغيل",
                fast: "سريع",
                slow: "بطيء"
            },
            hinavaEcoThermostatStateF: "تشغيل | الوضع: {0} | درجة الحرارة: {1}°م | سرعة المروحة: {2}",
            hinavaEcoThermostatStateTurboF: "تشغيل | الوضع: {0} | درجة الحرارة: {1}°م | تربو",
            sednaStateF: "تشغيل | الوضع: {0} | درجة الحرارة: {1}°م | سرعة المروحة: {2} | الحالة مسبقة الضبط: {3}",
            temperatureConditionF: {
                0: "درجة حرارة البيئة: انخفضت عن {0}°م",
                1: "درجة حرارة البيئة: وصلت إلى {0}°م",
                2: "درجة حرارة البيئة: تجاوزت {0}°م"
            },
            humidityConditionF: {
                0: "الرطوبة: انخفضت عن {0}%",
                1: "الرطوبة: وصلت إلى {0}%",
                2: "الرطوبة: تجاوزت {0}%"
            },
            brighnessConditionF: {
                0: "مستوى الإضاءة: انخفض عن “{0}”",
                1: "مستوى الإضاءة: وصل إلى “{0}”",
                2: "مستوى الإضاءة: تجاوز “{0}”"
            },
            coolerPowerSection: "طاقة",
            coolerPumpSection: "مضخة",
            coolerFanSection: "مروحة",
            didSetToSlow: "ضبط على بطيء",
            didSetToFast: "ضبط على سريع",
            willSetToSlow: "ضبط على بطيء",
            willSetToFast: "ضبط على سريع",
            run: "تشغيل",
            scenarioNameF: "مشهد {0}"
        },
        timezoneReset: "إعادة ضبط",
        timezoneStr: {
            "Asia/Tehran": "إيران",
            "Asia/Baghdad": "العراق"
        },
        createBindProcess: {
            editAutomation: "تعديل الأتمتة",
            createAutomation: "إنشاء أتمتة",
            createAutomationInfo: "تتيح لك الأتمتة التحكم في أجهزتك الذكية تلقائياً في ظروف محددة مسبقاً.",
            if: "إذا",
            then: "ثم",
            ifManyInfo: "(حدث أي من هذه الشروط)",
            thenManyInfo: "(نفذ كل هذه المهام)",
            create: "إنشاء",
            delete: "حذف",
            areYouSure: "هل أنت متأكد؟",
            deleteIt: "احذفه",
            keepIt: "لا، احتفظ به",
            addCondition: "إضافة شرط",
            addAnotherCondition: "إضافة شرط آخر",
            noCondition: "قم بتعديل الأتمتة لإضافة شرط",
            addStatement: "إضافة مهمة",
            addAnotherStatement: "إضافة مهمة أخرى",
            noStatement: "قم بتعديل الأتمتة لإضافة مهمة",
            participatesInCycle: "تشارك هذه الأتمتة في حلقة تكرارية.\n قم بتعديل الأتمتة الخاصة بك وأزل الحلقة.",
            setDelay: "تأخير التنفيذ",
            setDelayPageTitle: "ضبط تأخير التنفيذ",
            setDelayButton: "ضبط",
            setPeriod: "فترة الفعالية",
            setPeriodPageTitle: "ضبط فترة الفعالية",
            setPeriodButton: "ضبط",
            advancedOptions: "خيارات متقدمة",
            delay: "تأخير",
            period: "الفترة الزمنية",
            to: "إلى",
            to_: "إلى",
            clear: "مسح",
            name: "الاسم",
            namePlaceHolder: "مثل 'أمن المنزل' أو 'إعداد الشاي'",
            youMustEnterAName: "يجب عليك إدخال اسم للأتمتة",
            dayOfTheWeek: {
                title: "يوم الأسبوع",
                days: [
                    "ح",
                    "ج",
                    "ن",
                    "ث",
                    "ر",
                    "خ",
                    "ج"
                ],
                daysLong: [
                    "السبت",
                    "الأحد",
                    "الإثنين",
                    "الثلاثاء",
                    "الأربعاء",
                    "الخميس",
                    "الجمعة"
                ],
                allDays: "يمكن تفعيل الأتمتة في أي يوم.",
                selectiveDays: d => `يمكن تنفيذ الأتمتة فقط في أيام ${d}.`,
                comma: "، ",
                and2: "و",
                andM: "، و",
                noday: "لا يمكن تفعيل الأتمتة في أي يوم من أيام الأسبوع.",
                nodayEdit: "قم بتعديل الأتمتة لاختيار يوم واحد على الأقل"
            },
            timezone: "المنطقة الزمنية",
            selectIfEventType: "اختر نوع الشرط",
            device: "جهاز",
            scenario: "مشهد",
            time: "جدول زمني",
            selectStatementType: "اختر نوع المهمة",
            call: "اتصال",
            sms: "رسالة نصية (SMS)",
            notify: "تنبيه",
            email: "بريد إلكتروني",
            selectDevice: "اختر جهازاً",
            selectScenario: "اختر مشهداً",
            whenTempIf: "إذا كانت درجة الحرارة",
            chooseOneOfTheseConditions: "اختر أحد هذه الشروط",
            whenConditionComparison: {
                lower: "أقل من",
                equal: "يساوي",
                higher: "أعلى من"
            },
            goToState: "يضبط هذه الحالة",
            whenTheClockShowsTheseNumbers: "حدد وقت التنفيذ",
            chosseAddress: "اختر العنوان",
            chosseNumber: "اختر الرقم",
            youMustEnterAnAddress: "يجب عليك إدخال عنوان",
            youMustEnterANumber: "يجب عليك إدخال رقم",
            phonenumber: "رقم المحمول أو الهاتف الأرضي",
            next: "التالي",
            tvToggleOnOff: "تبديل التشغيل/الإيقاف",
            tvMute: "تبديل كتم الصوت",
            tvChannelTitle: "الذهاب إلى قناة",
            tvChannelLabel: "رقم القناة",
            tvYouMustEnterANumber: "يجب عليك إدخال رقم القناة"
        },
        messageCenter: "مركز الرسائل",
        messageCenterLoadingText: "جارٍ تحميل قائمة الرسائل",
        messageCenterCollapseText: "عرض أقل",
        messageCenterUncollapseText: "عرض المزيد",
        updateNotification: {
            hubTitle: "تحديث برنامج الموزع",
            clientTitle: "تحديث تطبيق العميل",
            changeHome: "تغيير المنزل",
            gotIt: "فهمت",
            update: "تحديث",
            later: "لاحقاً",
            criticalMessage: "لا يمكنك الاتصال بمنزلك لأن برنامج الموزع قديم. يرجى تحديثه.",
            message: "برنامج الموزع قديم. يمكنك بدء التحديث عن بعد من العميل.",
            clientMessage: "تطبيق العميل قديم. يمكنك بدء التحديث الآن.",
            nonAdminMessage: "برنامج الموزع قديم. يرجى تحديث برامجه.",
            nonOTAMessage: "برنامج الموزع قديم. يرجى الرجوع إلى الموزع وتحديث برامجه."
        },
        askPushPopup: {
            title: "تفعيل التنبيهات",
            body: "احصل على أقصى استفادة من منزلك الذكي من خلال البقاء على اطلاع بكل ما يحدث.",
            allow: "السماح بالتنبيهات",
            later: "لاحقاً"
        },
        availabilityPopup: {
            removed: {
                title: "هذا المنزل غير متاح",
                body: "هذا المنزل غير متاح ولا يمكن الاتصال به."
            },
            offline: {
                title: "الموزع المركزي غير متصل بالإنترنت",
                body: "الموزع المركزي غير متصل بالإنترنت. يرجى التحقق من اتصال الإنترنت للموزع المركزي. ستستمر محاولات الاتصال في الخلفية."
            },
            shouldlogin: {
                title: "إعادة تسجيل الدخول إلى Solo Cloud",
                body: "انتهت جلستك. يرجى تسجيل الدخول مرة أخرى إلى Solo Cloud باستخدام رقم هاتفك وإضافة المنزل إلى قائمتك."
            },
            changeHome: "تغيير المنزل",
            ok: "موافق"
        },
        otaReport: {
            title: {
                downloading: "جارٍ التنزيل …",
                installing: "جارٍ التثبيت …",
                done: "تم",
                error: "خطأ",
                formatTitleValue: (title, value) => `${title} %${value}`,
            },
            infoGeneral: "يرجى التحلي بالصبر وعدم إغلاق جهازك.\n يمكنك إغلاق هذه الصفحة أو التبديل بين التطبيقات، فسيستمر التقدم في الخلفية.",
            infoError: "يرجى المحاولة مرة أخرى وإذا تكرر الأمر، اتصل بالدعم.",
            infoDone: "اكتمل التحديث بنجاح."
        },
        aiChat: {
            listening: "جارٍ الاستماع ...",
            thinking: "جارٍ التفكير ...",
            clickToTalk: "اضغط للتحدث",
            errorNotAllowed: "للأسف هذه الميزة غير متوفرة لجهازك"
        }
    }
}

export default stringsData;